/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateViewRequest = {
  userName?: string | null,
  dashboardName?: string | null,
  viewName?: string | null,
  viewData?: string | null,
};

export type CreateViewResponse = {
  __typename: "CreateViewResponse",
  id?: string | null,
  error?: ErrorResponse | null,
};

export type ErrorResponse = {
  __typename: "ErrorResponse",
  message?: string | null,
};

export type UpdateViewRequest = {
  userName?: string | null,
  dashboardName?: string | null,
  viewName?: string | null,
  viewData?: string | null,
};

export type UpdateViewResponse = {
  __typename: "UpdateViewResponse",
  id?: string | null,
  error?: ErrorResponse | null,
};

export type CreateReviewInput = {
  requester: string,
  system: string,
  diffJson: string,
  reviewDescription?: string | null,
  resourceIdentifier: string,
};

export type StatusOutput = {
  __typename: "StatusOutput",
  status?: string | null,
};

export type CreateSystemInput = {
  systemId: string,
  systemDescription?: string | null,
  reviewerReqCount?: number | null,
  systemAllowList?: string | null,
  ldapGroup?: string | null,
};

export type CreateUserInput = {
  userId: string,
  userName?: string | null,
};

export type AddCommentInput = {
  reviewId: string,
  userId: string,
  comment?: string | null,
};

export type ManageReviewRequest = {
  reviewId: string,
  action: Action,
};

export enum Action {
  CANCEL_REVIEW = "CANCEL_REVIEW",
  MERGE_REVIEW = "MERGE_REVIEW",
}


export type ManageReviewerReviewRequest = {
  userId: string,
  reviewId: string,
  reviewerStatus: ReviewerStatus,
};

export enum ReviewerStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DENIED = "DENIED",
}


export type ManageReviewerReviewResponse = {
  __typename: "ManageReviewerReviewResponse",
  status?: string | null,
  review?: ReviewInfo | null,
  reviewStatus?: string | null,
  configStatus?: string | null,
};

export type ReviewInfo = {
  __typename: "ReviewInfo",
  reviewId?: string | null,
  reviewStatus?: ReviewStatus | null,
  reviewJson?: string | null,
  system?: string | null,
  timestamp?: string | null,
  requesterId?: string | null,
  resourceIdentifier?: string | null,
  reviewers?: Array< string | null > | null,
  reviewDescription?: string | null,
  reviewedTimestamp?: string | null,
};

export enum ReviewStatus {
  PENDING = "PENDING",
  MERGED = "MERGED",
  APPROVED = "APPROVED",
  DENIED = "DENIED",
  CANCELLED = "CANCELLED",
}


export type CreateConfigWithReviewInput = {
  system: string,
  reviewDescription?: string | null,
  tenantName: string,
  configName: string,
  parentConfig: string,
  versionDescription: string,
  configType: ConfigType,
  configsJson?: string | null,
  user: string,
  version?: number | null,
};

export enum ConfigType {
  CONFIGURATION = "CONFIGURATION",
  FEATURE_FLAG = "FEATURE_FLAG",
  global = "global",
  parent = "parent",
  child = "child",
}


export type CreateConfigWithReviewOutput = {
  __typename: "CreateConfigWithReviewOutput",
  reviewStatus?: string | null,
  status?: string | null,
};

export type CreateVersionWithReviewInput = {
  system: string,
  reviewDescription?: string | null,
  tenantName: string,
  configName: string,
  parentConfig: string,
  versionDescription: string,
  configType: ConfigType,
  configsJson?: string | null,
  user: string,
  version?: number | null,
};

export type CreateVersionWithReviewOutput = {
  __typename: "CreateVersionWithReviewOutput",
  reviewStatus?: string | null,
  status?: string | null,
};

export type CreateSandboxRequest = {
  sandbox_name: string,
  owner_bindle_id?: string | null,
  allocation_types?: Array< AllocationType | null > | null,
};

export enum AllocationType {
  opex_allocation = "opex_allocation",
  gl_simulation = "gl_simulation",
}


export type Sandbox = {
  __typename: "Sandbox",
  sandbox_id: string,
  resource_key: string,
  status_key?: string | null,
  resource_id?: string | null,
  resource_type?: ResourceType | null,
  is_active?: boolean | null,
  created_at?: number | null,
  status?: SandboxStatus | null,
  sandbox_name?: string | null,
  allocation_types?: Array< AllocationType | null > | null,
};

export enum ResourceType {
  SANDBOX = "SANDBOX",
  INPUT = "INPUT",
  INPUT_INLINE = "INPUT_INLINE",
  SIM = "SIM",
  SIM_SHARED = "SIM_SHARED",
  REPORT = "REPORT",
}


export enum SandboxStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}


export type UpdateSandboxRequest = {
  sandbox_name?: string | null,
  status?: string | null,
  allocation_types?: Array< AllocationType | null > | null,
};

export enum InputType {
  allocation_mapping = "allocation_mapping",
  allocation_definition = "allocation_definition",
  manual_journal_entry = "manual_journal_entry",
  custom_driver = "custom_driver",
}


export type Sim = {
  __typename: "Sim",
  sandbox_id: string,
  resource_key: string,
  status_key: string,
  resource_id: string,
  resource_type: ResourceType,
  is_active: boolean,
  name?: string | null,
  status: SimStatus,
  created_at: number,
  updated_at?: number | null,
  started_at?: number | null,
  finished_at?: number | null,
  error_msg?: string | null,
  configs?: string | null,
  allocation_type: AllocationType,
  input_ids?: Array< string | null > | null,
  mwaa_env?: string | null,
  dag_run_id?: string | null,
  scenario?: string | null,
  // Using string instead of enum to support names like "R&O Current", without having to map manually
  timeRange?: Array< string | null > | null,
  dag_tasks_status?: string | null,
  // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
  report_id?: string | null,
  is_shared?: boolean | null,
  userAlias: string,
  created_by?: string | null,
  updated_by?: string | null,
  started_by?: string | null,
  is_input_selected?: boolean | null,
  published_to_fpaone?: boolean | null,
  fpaone_publish_status?: string | null,
  commentary_status?: CommentaryStatus | null,
  sandbox_name?: string | null,
  shared_to_sandbox_ids?: Array< string | null > | null,
  shared_from_sandbox_id?: string | null,
  shared_from_sandbox_name?: string | null,
  comments?: string | null,
  allocation_pools?: string | null,
  ticket_id?: string | null,
  simulation_tag?: string | null,
  commentary_run_url?: string | null,
};

export enum SimStatus {
  CREATED = "CREATED",
  STARTED = "STARTED",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export enum CommentaryStatus {
  NOT_GENERATED = "NOT_GENERATED",
  IN_PROGRESS = "IN_PROGRESS",
  GENERATED = "GENERATED",
  FAILED = "FAILED",
}


export type UserInput = {
  __typename: "UserInput",
  sandbox_id: string,
  resource_key: string,
  status_key: string,
  resource_id: string,
  resource_type: ResourceType,
  is_active: boolean,
  created_at: number,
  status: InputStatus,
  input_type: InputType,
  allocation_type: AllocationType,
  s3_path?: string | null,
  userAlias?: string | null,
  dictionary_input_id?: string | null,
  source_id?: string | null,
  source_type?: InputDataSourceType | null,
  configs?: string | null,
  sim_resource_key?: string | null,
};

export enum InputStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}


export enum InputDataSourceType {
  DATA_INPUT = "DATA_INPUT",
  HYDROS = "HYDROS",
}


export type CreateSimRequest = {
  name?: string | null,
  configs?: string | null,
  allocation_type?: AllocationType | null,
  scenario?: string | null,
  timeRange?: Array< string | null > | null,
  input_ids?: Array< string | null > | null,
  userAlias: string,
};

export type UpdateSimRequest = {
  name?: string | null,
  configs?: string | null,
  allocation_type?: AllocationType | null,
  scenario?: string | null,
  timeRange?: Array< string | null > | null,
  input_ids?: Array< string | null > | null,
  userAlias?: string | null,
};

export type UpdateSimStatusRequest = {
  status?: SimStatus | null,
  error_msg?: string | null,
  mwaa_env?: string | null,
  dag_run_id?: string | null,
  dag_tasks_status?: string | null,
  report_id?: string | null,
  userAlias: string,
};

export type ShareSimRequest = {
  share_to_sandbox_id: string,
  userAlias: string,
  comments: string,
};

export type UpdateConfigurationResponse = {
  __typename: "UpdateConfigurationResponse",
  content?: string | null,
};

export type CreateScenarioRequest = {
  scenario_name: string,
  start_period: string,
  end_period: string,
  default_public: boolean,
  display_period: boolean,
};

export type Scenario = {
  __typename: "Scenario",
  scenario_name: string,
  start_period: string,
  end_period: string,
  default_public: boolean,
  created_at: number,
  status: ScenarioStatus,
  status_key: string,
  resource_key: string,
  display_period: boolean,
  resource_id: string,
  sandbox_id?: string | null,
  allocation_type?: AllocationType | null,
};

export enum ScenarioStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}


export type UpdateScenarioRequest = {
  scenario_name: string,
  start_period: string,
  end_period: string,
  default_public: boolean,
  display_period: boolean,
  resource_id: string,
};

export type EnableScenarioRequest = {
  scenario_name: string,
  resource_id: string,
};

export type DisableScenarioRequest = {
  scenario_name: string,
  resource_id: string,
};

export enum UploadStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}


export type UploadStatusType = {
  __typename: "UploadStatusType",
  status: UploadStatus,
  validateError?: Array< string | null > | null,
  errorDownloadUrl?: Array< string | null > | null,
};

export type CustomDriverInput = {
  input_resource_key?: string | null,
  datasource_type?: InputSourceType | null,
  driver_id?: string | null,
};

export enum InputSourceType {
  RESTATEMENT = "RESTATEMENT",
  PRODUCTION = "PRODUCTION",
  PAST_UPLOAD = "PAST_UPLOAD",
  DATA_INPUT_UPLOAD = "DATA_INPUT_UPLOAD",
  A3S_RESTATEMENT = "A3S_RESTATEMENT",
}


export enum DownloadType {
  INPUT = "INPUT",
  CHANGE_LOG = "CHANGE_LOG",
  SIMULATION_CHANGE_REQUEST = "SIMULATION_CHANGE_REQUEST",
}


export type GetInputContentDownloadUrlResponse = {
  __typename: "GetInputContentDownloadUrlResponse",
  download_url?: string | null,
  error_msg?: string | null,
  status?: DownloadStatus | null,
};

export enum DownloadStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}


export type StartFileUploadInput = {
  simulationKey: string,
  fileName: string,
  fileType: string,
  customMetaData: string,
  user: string,
  inputName?: string | null,
};

export type StartFileUploadResponse = {
  __typename: "StartFileUploadResponse",
  metaDataId: string,
  Url: string,
  message?: string | null,
  status?: UploadStatus | null,
};

export type LinkFileUploadInput = {
  simulationKey: string,
  metadataId: string,
  user: string,
};

export type LinkFileUploadResponse = {
  __typename: "LinkFileUploadResponse",
  status: UploadStatus,
  costpoolCount?: number | null,
  message?: string | null,
};

export type FileUploadStatusResponse = {
  __typename: "FileUploadStatusResponse",
  metadataId: string,
  simulationKey: string,
  status: string,
  errors?: Array< string | null > | null,
};

export type CancelFileUploadInput = {
  simulationKey: string,
  metadataId: string,
  user: string,
};

export type CancelFileUploadResponse = {
  __typename: "CancelFileUploadResponse",
  status: UploadStatus,
  message?: string | null,
};

export type CreateConfigurationRequest = {
  tenantName: string,
  configName: string,
  parentConfig: string,
  versionDescription: string,
  configType: ConfigType,
  configsJson?: string | null,
  user: string,
};

export type CreateConfigurationResponse = {
  __typename: "CreateConfigurationResponse",
  string?: string | null,
};

export type CreateTenantRequest = {
  tenantName: string,
  configsJson?: string | null,
  user: string,
  bindleID: string,
};

export type ValidateAndExportRequest = {
  inputName: string,
  user: string,
  data: Array< Array< string | null > >,
  attributeList: Array< string >,
};

export type ValidateAndExportResponse = {
  __typename: "ValidateAndExportResponse",
  errors?:  Array<ErrorDetail | null > | null,
  dataTarget?: DataTargetDetail | null,
  status?: ExportStatus | null,
  message?: string | null,
};

export type ErrorDetail = {
  __typename: "ErrorDetail",
  rowNumber?: number | null,
  attributeName?: string | null,
  attributeValue?: string | null,
  errorMessage?: string | null,
  suggestion?: string | null,
};

export type DataTargetDetail = {
  __typename: "DataTargetDetail",
  dataTargetType?: string | null,
  filePath?: string | null,
};

export enum ExportStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  INVALID = "INVALID",
}


export type CancelStepFunctionRequest = {
  metaDataId: string,
  executionId: string,
};

export type CancelStepFunctionStatus = {
  __typename: "CancelStepFunctionStatus",
  status?: string | null,
  message?: string | null,
};

export type CreateGFTOneNotificationRequestInput = {
  notificationType: NotificationType,
  data?: NotificationDataInput | null,
  app: string,
  stage: string,
  channels?: Array< string > | null,
  recipients?: Array< string > | null,
  isSplitGroup?: boolean | null,
  eventType: string,
  resourceId?: string | null,
  sender?: string | null,
};

export enum NotificationType {
  TRANSACTIONAL = "TRANSACTIONAL",
  NON_TRANSACTIONAL = "NON_TRANSACTIONAL",
}


export type NotificationDataInput = {
  title?: string | null,
  description?: string | null,
  content?: string | null,
  additionalInfo?: string | null,
  redirectTo?: string | null,
};

export type CreateGFTOneNotificationRequestOutPut = {
  __typename: "CreateGFTOneNotificationRequestOutPut",
  allNotifications?:  Array<eachNotification | null > | null,
};

export type eachNotification = {
  __typename: "eachNotification",
  id?: string | null,
  app?: string | null,
  channel?: string | null,
  stage?: string | null,
  data?: NotificationDetail | null,
  recipients?: Array< string | null > | null,
  notificationType?: NotificationType | null,
  isSplitGroup?: boolean | null,
  sender?: string | null,
};

export type NotificationDetail = {
  __typename: "NotificationDetail",
  title?: string | null,
  description?: string | null,
  content?: string | null,
  additionalInfo?: string | null,
  redirectTo?: string | null,
};

export type CreateGFTOneUserSubscriptionRequest = {
  recipient: string,
  app: string,
  stage: string,
  eventType: string,
  resourceId?: string | null,
  channel: string,
  createdOn?: number | null,
  lastModifiedOn?: number | null,
  expiresOn?: number | null,
};

export type CreateGFTOneUserSubscriptionResponse = {
  __typename: "CreateGFTOneUserSubscriptionResponse",
  id: string,
  status?: string | null,
  app?: string | null,
};

export type DeleteGFTOneUserSubscriptionRequest = {
  id: string,
};

export type DeleteGFTOneUserSubscriptionResponse = {
  __typename: "DeleteGFTOneUserSubscriptionResponse",
  id: string,
  status?: string | null,
};

export type UpdateGFTOneUserSubscriptionRequest = {
  id: string,
  recipient?: string | null,
  app?: string | null,
  stage?: string | null,
  eventType?: string | null,
  resourceId?: string | null,
  channel?: string | null,
  createdOn?: number | null,
  lastModifiedOn?: number | null,
  expiresOn?: number | null,
};

export type UpdateGFTOneUserSubscriptionResponse = {
  __typename: "UpdateGFTOneUserSubscriptionResponse",
  id: string,
  status?: string | null,
};

export type UpdateGFTOneUINotificationRequest = {
  id: string,
  recipient?: string | null,
  app?: string | null,
  stage?: string | null,
  eventType?: string | null,
  resourceId?: string | null,
  channel?: string | null,
  createdOn?: number | null,
  lastModifiedOn?: number | null,
  expiresOn?: number | null,
  read?: boolean | null,
};

export type UpdateGFTOneUINotificationResponse = {
  __typename: "UpdateGFTOneUINotificationResponse",
  id: string,
  status?: string | null,
};

export type GFTOneNotificationsInput = {
  alias: string,
  stage: string,
  system?: string | null,
  seen?: boolean | null,
};

export type getListOfNotifications = {
  __typename: "getListOfNotifications",
  items?:  Array<UINotification | null > | null,
};

export type UINotification = {
  __typename: "UINotification",
  id?: string | null,
  app?: string | null,
  channel?: string | null,
  alias?: string | null,
  created_at?: string | null,
  eventType?: string | null,
  stageSystemKey?: string | null,
  seen?: boolean | null,
  read?: boolean | null,
  data?: NotificationDetail | null,
  sender?: string | null,
};

export type CreateBindleResourceRequest = {
  ownerBindleID: string,
  application: string,
  stage: string,
  resourceType: string,
  name: string,
  requestor: string,
};

export type CreateBindleResourceResponse = {
  __typename: "CreateBindleResourceResponse",
  resourceID?: string | null,
  status?: string | null,
};

export type CreateFpaoneProductsCatalogInput = {
  category: string,
  productId: string,
  subCategory?: string | null,
  url?: string | null,
  description?: string | null,
  name?: string | null,
  wiki?: string | null,
  productType?: string | null,
  status?: string | null,
  accessGroups?: Array< string | null > | null,
};

export type FpaoneProductsCatalog = {
  __typename: "FpaoneProductsCatalog",
  category: string,
  productId: string,
  subCategory?: string | null,
  url?: string | null,
  description?: string | null,
  name?: string | null,
  wiki?: string | null,
  productType?: string | null,
  status?: string | null,
  accessGroups?: Array< string | null > | null,
};

export type UpdateFpaoneProductsCatalogInput = {
  category: string,
  productId: string,
  subCategory?: string | null,
  url?: string | null,
  description?: string | null,
  name?: string | null,
};

export type DeleteFpaoneProductsCatalogInput = {
  category: string,
  productId: string,
};

export type CreateUserWorkspaceDetailsInput = {
  userId: string,
  productIds?: Array< string | null > | null,
};

export type UserWorkspaceDetails = {
  __typename: "UserWorkspaceDetails",
  userId: string,
  productIds?: Array< string | null > | null,
};

export type UpdateUserWorkspaceDetailsInput = {
  userId: string,
  productIds?: Array< string | null > | null,
};

export type DeleteUserWorkspaceDetailsInput = {
  userId: string,
};

export type TicketInput = {
  title: string,
  description: string,
  severity: TicketPriority,
  categorization: Array< TicketCategoryInput >,
  requester?: string | null,
};

export enum TicketPriority {
  SEV_1 = "SEV_1",
  SEV_2 = "SEV_2",
  SEV_3 = "SEV_3",
  SEV_4 = "SEV_4",
  SEV_5 = "SEV_5",
}


export type TicketCategoryInput = {
  key: string,
  value: string,
};

export type TicketyResponseDetails = {
  __typename: "TicketyResponseDetails",
  ticketyId: string,
};

export type CreateTicketInput = {
  title: string,
  description: string,
  severity: TicketPriority,
  category: string,
  type: string,
  item: string,
  assigneeNamespace?: IdentityNamespace | null,
  assignee?: string | null,
  assignedGroupNamespace?: IdentityNamespace | null,
  assignedGroup?: string | null,
  requesterNamespace?: IdentityNamespace | null,
  requester?: string | null,
};

export enum IdentityNamespace {
  MIDWAY = "MIDWAY",
  AWS = "AWS",
  AWS_ACCOUNT = "AWS_ACCOUNT",
  AWS_SERVICE_PRINCIPAL = "AWS_SERVICE_PRINCIPAL",
  APPLICATION = "APPLICATION",
  EMAIL_ALIAS = "EMAIL_ALIAS",
  EMAIL = "EMAIL",
  INVALID_EMAIL = "INVALID_EMAIL",
  RESOLVER_GROUP = "RESOLVER_GROUP",
  POSIX = "POSIX",
  LDAP = "LDAP",
  FLUXO = "FLUXO",
  REMEDY = "REMEDY",
  SYSTEM = "SYSTEM",
  SPECIAL_USER = "SPECIAL_USER",
  SPECIAL_GROUP = "SPECIAL_GROUP",
  UNKNOWN = "UNKNOWN",
}


export type CreateProductInput = {
  name: string,
  description: string,
  info?: string | null,
  alias?: string | null,
  productType: ProductType,
  accessGroups: Array< string >,
  ownerGroups?: Array< string > | null,
  QUICKSIGHT_DASHBOARD?: ProductConfigQuicksightInput | null,
  APLIQO_DASHBOARD?: ProductConfigApliqoInput | null,
  MICRO_FRONTEND?: ProductConfigMicroFrontendInput | null,
  NATIVE_EXTERNAL?: ProductConfigExternalInput | null,
  NATIVE_INTERNAL?: ProductConfigInternalInput | null,
  accessType: ProductsAccessType,
  requestAccessLink?: string | null,
  featured?: number | null,
  wiki?: string | null,
  poc: string,
  subCategoryId: string,
  categoryId?: string | null,
  fintalkEnabled?: boolean | null,
  fintalkProps?: string | null,
  ticketConfig?: ProductTicketConfigInput | null,
};

export enum ProductType {
  QUICKSIGHT_DASHBOARD = "QUICKSIGHT_DASHBOARD",
  APLIQO_DASHBOARD = "APLIQO_DASHBOARD",
  MICRO_FRONTEND = "MICRO_FRONTEND",
  NATIVE_EXTERNAL = "NATIVE_EXTERNAL",
  NATIVE_INTERNAL = "NATIVE_INTERNAL",
}


export type ProductConfigQuicksightInput = {
  accountId?: string | null,
  namespace?: string | null,
  dashboardId?: string | null,
  props?: string | null,
};

export type ProductConfigApliqoInput = {
  url?: string | null,
  props?: string | null,
};

export type ProductConfigMicroFrontendInput = {
  filePath?: string | null,
  exportApp?: string | null,
  props?: string | null,
};

export type ProductConfigExternalInput = {
  url?: string | null,
  props?: string | null,
};

export type ProductConfigInternalInput = {
  name?: string | null,
  props?: string | null,
};

export enum ProductsAccessType {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
}


export type ProductTicketConfigInput = {
  category?: string | null,
  type?: string | null,
};

export type ProductDetails = {
  __typename: "ProductDetails",
  productId: string,
  name: string,
  description: string,
  info?: string | null,
  alias?: string | null,
  subCategoryId: string,
  subCategoryName: string,
  categoryId?: string | null,
  categoryName?: string | null,
  status: StatusType,
  productType: ProductType,
  accessGroups: Array< string >,
  ownerGroups?: Array< string > | null,
  QUICKSIGHT_DASHBOARD?: ProductConfigQuicksight | null,
  APLIQO_DASHBOARD?: ProductConfigApliqo | null,
  MICRO_FRONTEND?: ProductConfigMicroFrontend | null,
  NATIVE_EXTERNAL?: ProductConfigExternal | null,
  NATIVE_INTERNAL?: ProductConfigInternal | null,
  accessType: ProductsAccessType,
  fintalkEnabled?: boolean | null,
  fintalkProps?: string | null,
  requestAccessLink?: string | null,
  featured?: number | null,
  wiki?: string | null,
  poc: string,
  ticketConfig?: ProductTicketConfig | null,
  createdAt: string,
  createdBy: string,
  updatedAt?: string | null,
  updatedBy?: string | null,
};

// UPDATED PRODUCT AND CATEGORY SCHEMA
export enum StatusType {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}


export type ProductConfigQuicksight = {
  __typename: "ProductConfigQuicksight",
  accountId?: string | null,
  namespace?: string | null,
  dashboardId?: string | null,
  props?: string | null,
};

export type ProductConfigApliqo = {
  __typename: "ProductConfigApliqo",
  url?: string | null,
  props?: string | null,
};

export type ProductConfigMicroFrontend = {
  __typename: "ProductConfigMicroFrontend",
  filePath?: string | null,
  exportApp?: string | null,
  props?: string | null,
};

export type ProductConfigExternal = {
  __typename: "ProductConfigExternal",
  url?: string | null,
  props?: string | null,
};

export type ProductConfigInternal = {
  __typename: "ProductConfigInternal",
  name?: string | null,
  props?: string | null,
};

export type ProductTicketConfig = {
  __typename: "ProductTicketConfig",
  category?: string | null,
  type?: string | null,
};

export type UpdateProductInput = {
  productId: string,
  name: string,
  description: string,
  info?: string | null,
  alias?: string | null,
  status: StatusType,
  productType: ProductType,
  accessGroups: Array< string >,
  ownerGroups?: Array< string > | null,
  QUICKSIGHT_DASHBOARD?: ProductConfigQuicksightInput | null,
  APLIQO_DASHBOARD?: ProductConfigApliqoInput | null,
  MICRO_FRONTEND?: ProductConfigMicroFrontendInput | null,
  NATIVE_EXTERNAL?: ProductConfigExternalInput | null,
  NATIVE_INTERNAL?: ProductConfigInternalInput | null,
  accessType: ProductsAccessType,
  requestAccessLink?: string | null,
  featured?: number | null,
  wiki?: string | null,
  poc: string,
  subCategoryId: string,
  categoryId?: string | null,
  fintalkEnabled?: boolean | null,
  fintalkProps?: string | null,
  ticketConfig?: ProductTicketConfigInput | null,
};

export type CreateCategoryInput = {
  categoryName: string,
  sortOrder?: number | null,
};

export type CategoryDetails = {
  __typename: "CategoryDetails",
  categoryId: string,
  categoryName: string,
  status: StatusType,
  sortOrder?: number | null,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
};

export type UpdateCategoryInput = {
  categoryId: string,
  categoryName: string,
  status: StatusType,
  sortOrder?: number | null,
};

export type CreateSubCategoryInput = {
  subCategoryName: string,
  parentCategoryId: string,
};

export type SubCategoryDetails = {
  __typename: "SubCategoryDetails",
  subCategoryId: string,
  subCategoryName: string,
  parentCategoryId: string,
  status: StatusType,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
};

export type UpdateSubCategoryInput = {
  subCategoryId: string,
  subCategoryName: string,
  parentCategoryId: string,
  status: StatusType,
};

export type CreateResourcesSectionInput = {
  sectionName: string,
  sortOrder?: number | null,
};

export type ResourcesSection = {
  __typename: "ResourcesSection",
  sectionId: string,
  sectionName: string,
  status?: StatusType | null,
  sortOrder?: number | null,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  subsections?:  Array<ResourcesSubsection | null > | null,
};

export type ResourcesSubsection = {
  __typename: "ResourcesSubsection",
  subsectionId: string,
  subsectionName: string,
  description?: string | null,
  wikiLink?: string | null,
  contentURL?: string | null,
  parentSectionId: string,
  status?: StatusType | null,
  sortOrder?: number | null,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
};

export type CreateResourcesSubsectionInput = {
  subsectionName: string,
  description?: string | null,
  wikiLink?: string | null,
  contentURL?: string | null,
  parentSectionId: string,
  sortOrder?: number | null,
};

export type UpdateResourcesSectionInput = {
  sectionId: string,
  sectionName?: string | null,
  sortOrder?: number | null,
  status?: StatusType | null,
};

export type UpdateResourcesSubsectionInput = {
  subsectionId: string,
  subsectionName?: string | null,
  description?: string | null,
  wikiLink?: string | null,
  contentURL?: string | null,
  parentSectionId?: string | null,
  sortOrder?: number | null,
  status?: StatusType | null,
};

export type UpdateAboutFPAOneInput = {
  about: string,
  poc: Array< string >,
  accessGroups: Array< string >,
};

export type AboutFPAOne = {
  __typename: "AboutFPAOne",
  aboutId: string,
  about: string,
  poc: Array< string >,
  accessGroups: Array< string >,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
};

export type CreateTicketForProductInput = {
  productId: string,
  title: string,
  description: string,
  severity: TicketPriority,
  item: string,
};

export type UpdateFederateMappingInput = {
  groups: Array< FederateGroupInput >,
};

export type FederateGroupInput = {
  value: string,
  type: FederateGroupType,
};

export enum FederateGroupType {
  LDAP = "LDAP",
  ANT = "ANT",
}


export type FederateMapperResponse = {
  __typename: "FederateMapperResponse",
  success: boolean,
  message?: string | null,
};

export type StartConfigQueryInput = {
  tableKey: string,
  guid?: string | null,
  filters?: string | null,
  includeColumns?: Array< string > | null,
  fetchAllPeriods?: boolean | null,
  runId?: string | null,
  targetTable?: string | null,
  outputTable?: string | null,
  dateColumn?: string | null,
  dateColumnType?: string | null,
  distinct?: boolean | null,
  groupBy?: Array< string > | null,
  datasetNames?: Array< string > | null,
  scenario?: string | null,
};

export type StartQueryResponse = {
  __typename: "StartQueryResponse",
  success: boolean,
  queryExecutionId?: string | null,
  countQueryExecutionId?: string | null,
  minPeriod?: string | null,
  maxPeriod?: string | null,
  error?: string | null,
  data?: string | null,
};

export type CreateRecordInput = {
  tableName: string,
  data: string,
};

export type RecordResponse = {
  __typename: "RecordResponse",
  success: boolean,
  message: string,
  data?: string | null,
  tableName: string,
  recordId?: string | null,
  error?: string | null,
  // Optional outcome of the BE update post-processor side-effect (e.g.
  // Kinesis approval-event publish for cashflow). Tri-valued via
  // presence: omitted when no side-effect ran (most processes / writes),
  // ``true`` on a successful publish, ``false`` on a failed publish.
  // The FE reads this on ``updateRecord`` to append a "Notification
  // sent" clause to the success banner — see ``RunDetails.tsx``.
  notificationsPublished?: boolean | null,
};

export type UpdateRecordInput = {
  tableName: string,
  id: string,
  data: string,
  keyField?: string | null,
  expectedVersion?: number | null,
};

export type DeleteRecordInput = {
  tableName: string,
  id: string,
  keyField?: string | null,
};

export type GenerateNewRunModularInput = {
  process: string,
  view: string,
  startPeriod: string,
  endPeriod: string,
  user: string,
  requestedDate: string,
  requestedTime: string,
  executionInfo: string,
  modelType: string,
  requiredInputs: string,
  tableInputs: string,
  runInfo: string,
  outputTable: string,
  dynamoUpdateFields: string,
  runIdPrefix?: string | null,
  extraFields?: string | null,
  timeoutMs?: number | null,
  runTypeId?: string | null,
};

export type GenerateNewRunResponse = {
  __typename: "GenerateNewRunResponse",
  success: boolean,
  message?: string | null,
  runId?: string | null,
  data?: string | null,
  error?: string | null,
};

export type ExportDynamoToS3Response = {
  __typename: "ExportDynamoToS3Response",
  success: boolean,
  message: string,
  runId?: string | null,
  data?: string | null,
  error?: string | null,
};

export type PrecomputeChartDependencyInput = {
  runId: string,
  actualsTable: string,
  outputTable: string,
};

export type MutationResponse = {
  __typename: "MutationResponse",
  success: boolean,
  data?: string | null,
  error?: string | null,
};

export type ExportForecastToS3Input = {
  runId: string,
  outputTable: string,
  process?: string | null,
};

export type ExportForecastResponse = {
  __typename: "ExportForecastResponse",
  success: boolean,
  presignedUrl?: string | null,
  fileName: string,
  expiresAt?: string | null,
  recordCount: number,
  data?: string | null,
  error?: string | null,
};

export type ExportActualsToS3Input = {
  tableKey: string,
  filters?: string | null,
  fileName?: string | null,
};

export type ComputeHierarchicalRollupInput = {
  table: string,
  filters?: string | null,
  periodColumn?: string | null,
  periodStart?: number | null,
  periodEnd?: number | null,
  factGuid?: string | null,
  factGuidPairs?: Array< GuidPeriodPairInput > | null,
  resolveFactGuid?: boolean | null,
  dimGuid?: string | null,
  resolveDimGuid?: boolean | null,
  segments: Array< RollupSegmentInput >,
  amountColumns: Array< string >,
  rowLimit?: number | null,
  sync?: boolean | null,
};

export type GuidPeriodPairInput = {
  guid: string,
  period?: number | null,
};

export type RollupSegmentInput = {
  column: string,
  hierarchydim?: string | null,
  selectedChildId: string,
  label?: string | null,
  emitActual?: boolean | null,
};

export type ComputeHierarchicalRollupResponse = {
  __typename: "ComputeHierarchicalRollupResponse",
  success: boolean,
  data?: string | null,
  queryExecutionId?: string | null,
  error?: string | null,
};

export type PresignQueryResultInput = {
  queryExecutionId: string,
  fileName?: string | null,
  expiresInSeconds?: number | null,
};

export type PresignQueryResultResponse = {
  __typename: "PresignQueryResultResponse",
  success: boolean,
  presignedUrl?: string | null,
  fileName: string,
  expiresAt?: string | null,
  recordCount: number,
  data?: string | null,
  error?: string | null,
};

export type PutDrrApprovalCsvInput = {
  runId: string,
  topline: string,
  quarterEndDate: string,
};

export type PutDrrApprovalCsvResponse = {
  __typename: "PutDrrApprovalCsvResponse",
  success: boolean,
  bucket?: string | null,
  key?: string | null,
  error?: string | null,
};

export type WriteAthenaResultToDynamoInput = {
  queryExecutionId?: string | null,
  csvPresignedUrl?: string | null,
  targetTableName: string,
  runId?: string | null,
  requestedBy?: string | null,
};

export type WriteAthenaResultToDynamoResponse = {
  __typename: "WriteAthenaResultToDynamoResponse",
  success: boolean,
  taskId?: string | null,
  errorCode?: string | null,
  data?: string | null,
  error?: string | null,
};

export type GetSyncStatusResponse = {
  __typename: "GetSyncStatusResponse",
  statusCode?: number | null,
  data?: SyncStatus | null,
};

export type SyncStatus = {
  __typename: "SyncStatus",
  planSync?:  Array<SyncStatusJobDetail | null > | null,
  actualsSync?:  Array<SyncStatusJobDetail | null > | null,
};

export type SyncStatusJobDetail = {
  __typename: "SyncStatusJobDetail",
  startPeriod?: string | null,
  endPeriod?: string | null,
  jobTriggerTime?: string | null,
  jobStartTime?: string | null,
  jobNAWSEndTime?: string | null,
  jobEDXEndTime?: string | null,
  jobGalaxyEndTime?: string | null,
};

export type IsAuthorizedRequest = {
  resourceID?: string | null,
  actorID?: string | null,
};

export type IsAuthorizedResponse = {
  __typename: "IsAuthorizedResponse",
  isAuthorized?: boolean | null,
};

export type GetDashboardEmbedUrlRequest = {
  userName?: string | null,
  dashboardName?: string | null,
  filters?: string | null,
  skipUserCheck?: boolean | null,
};

export type GetDashboardEmbedUrlResponse = {
  __typename: "GetDashboardEmbedUrlResponse",
  url?: string | null,
  error?: ErrorResponse | null,
};

export type GetUserServiceAccessRequest = {
  userAlias?: string | null,
};

export type GetUserServiceAccessResponse = {
  __typename: "GetUserServiceAccessResponse",
  services?:  Array<UserServiceAccess | null > | null,
};

export type UserServiceAccess = {
  __typename: "UserServiceAccess",
  name?: string | null,
};

export type GetLoadFilterOptionsRequest = {
  dashboard: string,
  viewType: string,
  datasetname?: string | null,
  scenario_list?: Array< string | null > | null,
  actuals_month?: number | null,
};

export type GetLoadFilterOptionsResponse = {
  __typename: "GetLoadFilterOptionsResponse",
  filters?: string | null,
  error?: ErrorResponse | null,
};

export type GetRetrieveViewRequest = {
  userName?: string | null,
  dashboardName?: string | null,
  viewName?: string | null,
};

export type GetRetrieveViewResponse = {
  __typename: "GetRetrieveViewResponse",
  viewData?: string | null,
  error?: ErrorResponse | null,
};

export type LoadSavedViewsListRequest = {
  userName?: string | null,
  dashboardName?: string | null,
};

export type LoadSavedViewsListResponse = {
  __typename: "LoadSavedViewsListResponse",
  Views?:  Array<ViewItem | null > | null,
  error?: ErrorResponse | null,
};

export type ViewItem = {
  __typename: "ViewItem",
  viewData?: string | null,
};

export type FetchReviewsRequest = {
  system: string,
  beginTimestamp?: string | null,
  endTimestamp?: string | null,
  resourceIdentifier?: string | null,
  activeStatus?: ActiveStatus | null,
  fullReview?: boolean | null,
  limit?: number | null,
  user?: string | null,
};

export enum ActiveStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  ALL = "ALL",
}


export type FetchReviewsResponse = {
  __typename: "FetchReviewsResponse",
  reviews?:  Array<ReviewInfo | null > | null,
};

export type FetchReviewsByUserRequest = {
  userId: string,
};

export type FetchReviewsByUserResponse = {
  __typename: "FetchReviewsByUserResponse",
  reviewsRequestedByUser?:  Array<ReviewInfo | null > | null,
  reviewsToBeReviewedByUser?:  Array<ReviewInfo | null > | null,
};

export type CheckSystemPermissionInput = {
  systemId: string,
  userId: string,
};

export type CheckSystemPermissionOutput = {
  __typename: "CheckSystemPermissionOutput",
  hasAccess?: boolean | null,
};

export type FetchReviewByIdRequest = {
  reviewId: string,
};

export type FetchReviewByIdResponse = {
  __typename: "FetchReviewByIdResponse",
  review?: ReviewInfo | null,
};

export type CreateSIMTicketRequest = {
  title: string,
  description: string,
  service: string,
  requestor?: string | null,
};

export type CreateSIMTicketResponse = {
  __typename: "CreateSIMTicketResponse",
  ticketID?: string | null,
};

export type SandboxGroupMembership = {
  __typename: "SandboxGroupMembership",
  is_super_admin: boolean,
  member_of_groups?: Array< string | null > | null,
  sandboxes_accessible?:  Array<UserSandboxAccess | null > | null,
};

export type UserSandboxAccess = {
  __typename: "UserSandboxAccess",
  sandbox_id: string,
  sandbox_name: string,
  status?: SandboxStatus | null,
  allocation_types?: Array< AllocationType | null > | null,
  is_active: boolean,
  created_at?: number | null,
  permissions?: SandboxAccessMap | null,
};

export type SandboxAccessMap = {
  __typename: "SandboxAccessMap",
  SIM_RUN?: boolean | null,
  SIM_UPDATE?: boolean | null,
  IS_ADMIN?: boolean | null,
};

export type isAdminResponse = {
  __typename: "isAdminResponse",
  is_admin: boolean,
};

export type TableSandboxFilterRequest = {
  sandbox_id?: TableStringFilterRequest | null,
  status?: TableStringFilterRequest | null,
  sandbox_name?: TableStringFilterRequest | null,
};

export type TableStringFilterRequest = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  size?: ModelSizeRequest | null,
};

export type ModelSizeRequest = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type SandboxListPage = {
  __typename: "SandboxListPage",
  items?:  Array<Sandbox | null > | null,
  nextToken?: string | null,
};

export type GetAllocationConfigContentResponse = {
  __typename: "GetAllocationConfigContentResponse",
  content?: string | null,
  last_modified?: string | null,
};

export type AllocationConfigSchema = {
  __typename: "AllocationConfigSchema",
  column_schema?:  Array<AllocationConfigSchemaColumn | null > | null,
  query_schema?: string | null,
};

export type AllocationConfigSchemaColumn = {
  __typename: "AllocationConfigSchemaColumn",
  name?: string | null,
  label?: string | null,
  type?: string | null,
  required?: boolean | null,
  defaultValue?: string | null,
};

export type InputListPage = {
  __typename: "InputListPage",
  items?:  Array<UserInput | null > | null,
  nextToken?: string | null,
};

export type InputDictionaryDiff = {
  __typename: "InputDictionaryDiff",
  input_json?: string | null,
  input_schema?:  Array<AllocationConfigSchemaColumn > | null,
  total_input_count?: number | null,
  diff?: string | null,
  userAlias?: string | null,
  created_at: number,
};

export type SimBySandboxIdStatusFilterRequest = {
  name?: TableStringFilterRequest | null,
  allocation_type?: TableStringFilterRequest | null,
  userAlias?: TableStringFilterRequest | null,
  is_shared_by_me?: boolean | null,
  created_by?: TableStringFilterRequest | null,
};

export type SimListPage = {
  __typename: "SimListPage",
  items?:  Array<Sim | null > | null,
  nextToken?: string | null,
};

export type Report = {
  __typename: "Report",
  sandbox_id: string,
  resource_key: string,
  status_key: string,
  resource_id: string,
  resource_type: ResourceType,
  is_active: boolean,
  status: ReportStatus,
  created_at: number,
  sim_id: string,
};

export enum ReportStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}


export type SyncTimingResponse = {
  __typename: "SyncTimingResponse",
  allocationDefinitionSyncTime?: number | null,
  allocationMappingSyncTime?: number | null,
};

export type GetConfigurationsResponse = {
  __typename: "GetConfigurationsResponse",
  content?: string | null,
};

export type TableScenarioFilterRequest = {
  scenario_name?: TableStringFilterRequest | null,
  status?: TableStringFilterRequest | null,
  start_period?: TableStringFilterRequest | null,
  end_period?: TableStringFilterRequest | null,
};

export type ScenarioListPage = {
  __typename: "ScenarioListPage",
  items?:  Array<Scenario | null > | null,
  nextToken?: string | null,
};

export enum DriverType {
  STANDARD = "STANDARD",
  CUSTOM = "CUSTOM",
}


export type SimulationCostPool = {
  __typename: "SimulationCostPool",
  driver_type?: DriverType | null,
  costpool_id?: string | null,
  costpool_name?: string | null,
  driver_id?: string | null,
};

export type CustomDriverDatasource = {
  __typename: "CustomDriverDatasource",
  name?: string | null,
  created_time?: number | null,
  driver_id?: string | null,
  input_resource_key?: string | null,
  datasource_type?: InputSourceType | null,
};

export enum CustomDriverGroupBy {
  COSTPOOL = "COSTPOOL",
}


export type ListOfCustomDriverResponse = {
  __typename: "ListOfCustomDriverResponse",
  custom_driver_id?: string | null,
  custom_drivers?:  Array<SimulationCustomDriverMetadata | null > | null,
  custom_driver_count?: number | null,
  costpool_count?: number | null,
};

export type SimulationCustomDriverMetadata = {
  __typename: "SimulationCustomDriverMetadata",
  costpool_id?: string | null,
  timePeriod?: string | null,
  driver_id?: string | null,
  input_resource_key?: string | null,
  datasource_type?: InputSourceType | null,
};

export type GetMaxPeriodForDataSetsInput = {
  dataset_list?: Array< string | null > | null,
  scenario?: string | null,
};

export type GetMaxPeriodForDataSetsResponse = {
  __typename: "GetMaxPeriodForDataSetsResponse",
  maxPeriodForDataSetList:  Array<DatasetMaxPeriod | null >,
  maxPeriodForDataSets?: number | null,
};

export type DatasetMaxPeriod = {
  __typename: "DatasetMaxPeriod",
  dataSetName: string,
  maxPeriod: number,
};

export enum SearchType {
  COSTPOOL = "COSTPOOL",
  COST_CENTER = "COST_CENTER",
}


export type SearchResponse = {
  __typename: "SearchResponse",
  results:  Array<SearchResult >,
};

export type SearchResult = {
  __typename: "SearchResult",
  id: string,
  name: string,
};

export enum CostPoolListType {
  COSTPOOL = "COSTPOOL",
  COST_CENTER = "COST_CENTER",
}


export type ListCostPoolsResponse = {
  __typename: "ListCostPoolsResponse",
  costPools:  Array<CostPoolDetails >,
  hasMore: boolean,
};

export type CostPoolDetails = {
  __typename: "CostPoolDetails",
  allocationPoolId: string,
  allocationPoolName: string,
  costCenters?: Array< string > | null,
  financeOwner?: string | null,
  lastUpdatedDate?: string | null,
};

export type GetCostPoolDetailsResponse = {
  __typename: "GetCostPoolDetailsResponse",
  costPoolId: string,
  version: CostPoolVersion,
  definitions: string,
  mappings: string,
  driverDistribution: string,
};

export type CostPoolVersion = {
  __typename: "CostPoolVersion",
  id: number,
  name: string,
};

export type GetConfigurationRequest = {
  tenantName: string,
  configName: string,
  version?: number | null,
};

export type GetConfigurationResponse = {
  __typename: "GetConfigurationResponse",
  configs?: string | null,
  metadata?: string | null,
  user?: string | null,
};

export type TenantsList = {
  __typename: "TenantsList",
  tenants?: Array< string > | null,
};

export type GetListOfConfigsRequest = {
  tenant: string,
};

export type ConfigsList = {
  __typename: "ConfigsList",
  configs?:  Array<ConfigInfo | null > | null,
};

export type ConfigInfo = {
  __typename: "ConfigInfo",
  configName: string,
  configType?: ConfigType | null,
  parentConfig?: string | null,
};

export type RetrieveConfigListInput = {
  configName: string,
  version?: number | null,
};

export type RetrieveConfigurationsResponse = {
  __typename: "RetrieveConfigurationsResponse",
  configsMap?:  Array<ConfigMapList | null > | null,
};

export type ConfigMapList = {
  __typename: "ConfigMapList",
  configName?: string | null,
  parentConfig?: string | null,
  configType?: ConfigType | null,
  configParams?: string | null,
  versionDescription?: string | null,
  metadata?: string | null,
  user?: string | null,
};

export type GetListOfAccessibleTenantsRequest = {
  user: string,
  operation?: string | null,
};

export type GetListOfAccessibleTenantsResponse = {
  __typename: "GetListOfAccessibleTenantsResponse",
  tenants?:  Array<TenantInfo > | null,
};

export type TenantInfo = {
  __typename: "TenantInfo",
  tenantName?: string | null,
  operation?: string | null,
};

export type GetSchemaRequest = {
  inputName: string,
  user: string,
};

export type GetSchemaResponse = {
  __typename: "GetSchemaResponse",
  attributeList?:  Array<AttributeSchema | null > | null,
};

export type AttributeSchema = {
  __typename: "AttributeSchema",
  attributeName?: string | null,
  attributeLabel?: string | null,
  attributeType?: string | null,
  isRequired?: boolean | null,
  isDisabled?: boolean | null,
  isHidden?: boolean | null,
  defaultValue?: string | null,
  description?: string | null,
  options?: Array< string | null > | null,
};

export type FetchExportedDataRequest = {
  inputName: string,
  metaDataID: string,
  version: number,
  user: string,
};

export type FetchExportedDataResponse = {
  __typename: "FetchExportedDataResponse",
  attributeList?: Array< string | null > | null,
  data?: Array< Array< string | null > | null > | null,
  status?: ExportStatus | null,
  message?: string | null,
};

export type FetchPreSignedUrlRequest = {
  inputName: string,
  fileName: string,
  fileType: string,
  user: string,
  customMetaData?: string | null,
};

export type FetchPreSignedUrlResponse = {
  __typename: "FetchPreSignedUrlResponse",
  url?: string | null,
  inputID?: string | null,
  status?: Status | null,
  message?: string | null,
  filePath?: string | null,
};

export enum Status {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  ERROR = "ERROR",
}


export type FetchDraftInputDetailsRequest = {
  user: string,
  metaDataID: string,
};

export type FetchDraftInputDetailsResponse = {
  __typename: "FetchDraftInputDetailsResponse",
  status?: string | null,
  errorAttributeList?: Array< string | null > | null,
};

export type DownloadErrorDataRequest = {
  user: string,
  inputName: string,
  metaDataID: string,
  fileName: string,
  fileType: string,
};

export type DownloadErrorDataResponse = {
  __typename: "DownloadErrorDataResponse",
  url?: string | null,
  status?: string | null,
  message?: string | null,
};

export type GFTOneUserSubscription = {
  __typename: "GFTOneUserSubscription",
  id: string,
  recipient?: string | null,
  app?: string | null,
  stage?: string | null,
  eventType?: string | null,
  resourceId?: string | null,
  channel?: string | null,
  createdOn?: number | null,
  lastModifiedOn?: number | null,
  expiresOn?: number | null,
};

export type GFTOneUINotificationCount = {
  __typename: "GFTOneUINotificationCount",
  count?: number | null,
};

export type IsMemberOfGroupRequest = {
  actorID: string,
  actorType: string,
  groupID: string,
  groupType: string,
};

export type IsMemberOfGroupResponse = {
  __typename: "IsMemberOfGroupResponse",
  isMember?: boolean | null,
  status?: string | null,
};

export type IsAuthorizedBindleLockRequest = {
  actorID: string,
  resourceID: string,
};

export type IsAuthorizedBindleLockResponse = {
  __typename: "IsAuthorizedBindleLockResponse",
  isAuthorized?: boolean | null,
  status?: string | null,
};

export type CanAccessRequest = {
  actorID: string,
  actorType: string,
  operation: string,
  stage: string,
  resourceType: string,
  resourceName: string,
};

export type CanAccessResponse = {
  __typename: "CanAccessResponse",
  isAuthorized?: boolean | null,
  status?: string | null,
};

export type CheckPermissionRequest = {
  actorID: string,
  operation?: string | null,
  stage: string,
  resourceType: string,
};

export type CheckPermissionResponse = {
  __typename: "CheckPermissionResponse",
  resourceList?:  Array<ResourceInfo | null > | null,
  status?: string | null,
};

export type ResourceInfo = {
  __typename: "ResourceInfo",
  operation?: string | null,
  namespace?: string | null,
  resourceType?: string | null,
  resourceName?: string | null,
};

export type CheckPermissionBatchRequest = {
  actorID: string,
  stage: string,
  resourceType?: Array< string > | null,
};

export type CheckPermissionBatchResponse = {
  __typename: "CheckPermissionBatchResponse",
  resourceTypeList?:  Array<ResourceInfoBatchObject | null > | null,
  status?: string | null,
};

export type ResourceInfoBatchObject = {
  __typename: "ResourceInfoBatchObject",
  resourceType?: string | null,
  resourceList?:  Array<ResourceInfo | null > | null,
};

export type ListMemberOfGroupRequest = {
  groupID: string,
  groupType: string,
};

export type ListMemberOfGroupResponse = {
  __typename: "ListMemberOfGroupResponse",
  listOfMembers?:  Array<MemberInfo | null > | null,
};

export type MemberInfo = {
  __typename: "MemberInfo",
  actorID?: string | null,
  actorType?: string | null,
};

export type ListBindleByOwnerRequest = {
  actorID: string,
};

export type ListBindleByOwnerResponse = {
  __typename: "ListBindleByOwnerResponse",
  listOfBindles?:  Array<BindleInfo | null > | null,
};

export type BindleInfo = {
  __typename: "BindleInfo",
  bindleID?: string | null,
  bindleName?: string | null,
};

export type FpaoneProductsCatalogConnection = {
  __typename: "FpaoneProductsCatalogConnection",
  items?:  Array<FpaoneProductsCatalog | null > | null,
};

export type TableUserWorkspaceDetailsFilterInput = {
  userId?: TableStringFilterInput | null,
  productIds?: TableStringFilterInput | null,
};

export type TableStringFilterInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  size?: ModelSizeInput | null,
};

export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type UserWorkspaceDetailsConnection = {
  __typename: "UserWorkspaceDetailsConnection",
  items?:  Array<UserWorkspaceDetails | null > | null,
  nextToken?: string | null,
};

export type AccountLock = {
  __typename: "AccountLock",
  accountName: string,
  lockStatus?: string | null,
};

export type ProductCategory = {
  __typename: "ProductCategory",
  categoryId: string,
  categoryName: string,
  subcategories?:  Array<ProductSubCategory | null > | null,
  status: StatusType,
  sortOrder?: number | null,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
};

export type ProductSubCategory = {
  __typename: "ProductSubCategory",
  subCategoryId: string,
  subCategoryName: string,
  parentCategoryId: string,
  status: StatusType,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
};

export type QuickSightUrlOutput = {
  __typename: "QuickSightUrlOutput",
  quicksightUrl?: string | null,
};

export type UserAccessRoles = {
  __typename: "UserAccessRoles",
  roles: Array< UserRoleType >,
};

export enum UserRoleType {
  USER = "USER",
  ADMIN = "ADMIN",
  PRODUCT_OWNER = "PRODUCT_OWNER",
}


export type CTINode = {
  __typename: "CTINode",
  id?: string | null,
  label?: string | null,
  name: string,
};

export enum ApplicationId {
  FPAONE = "FPAONE",
  STARMAP = "STARMAP",
  AIDA = "AIDA",
}


export type UserGroups = {
  __typename: "UserGroups",
  ldapGroups?: Array< string | null > | null,
  antGroups?: Array< string | null > | null,
};

export type ModularTableResponse = {
  __typename: "ModularTableResponse",
  success: boolean,
  data: Array< string >,
  queryExecutionId?: string | null,
  error?: string | null,
};

export type RunInfoLogResponse = {
  __typename: "RunInfoLogResponse",
  success: boolean,
  lines:  Array<RunInfoLogLine >,
  lastUpdated?: string | null,
  error?: string | null,
};

export type RunInfoLogLine = {
  __typename: "RunInfoLogLine",
  timestamp: string,
  level: string,
  message: string,
};

export type CsvFromS3Response = {
  __typename: "CsvFromS3Response",
  success: boolean,
  columns: Array< string >,
  rows: Array< string >,
  lastUpdated?: string | null,
  error?: string | null,
};

export type RunQueryResponse = {
  __typename: "RunQueryResponse",
  success: boolean,
  data: Array< string >,
  error?: string | null,
};

export type RunLineageResponse = {
  __typename: "RunLineageResponse",
  success: boolean,
  pairs: Array< string >,
  producer?: string | null,
  apiUrl?: string | null,
  tableName?: string | null,
  datasetName?: string | null,
  datasetMismatch?: boolean | null,
  error?: string | null,
};

export type TableSchemaResponse = {
  __typename: "TableSchemaResponse",
  success: boolean,
  data:  Array<TableColumn >,
  tableName: string,
  error?: string | null,
};

export type TableColumn = {
  __typename: "TableColumn",
  columnName: string,
  dataType: string,
  comment?: string | null,
};

export type LatestGuidResponse = {
  __typename: "LatestGuidResponse",
  success: boolean,
  guid?: string | null,
  error?: string | null,
};

export type GuidPeriodPairsResponse = {
  __typename: "GuidPeriodPairsResponse",
  success: boolean,
  pairs?:  Array<GuidPeriodPair > | null,
  truncated?: boolean | null,
  error?: string | null,
};

export type GuidPeriodPair = {
  __typename: "GuidPeriodPair",
  guid: string,
  period: string,
  s3Location?: string | null,
};

export type CheckPartitionsHaveFilesResponse = {
  __typename: "CheckPartitionsHaveFilesResponse",
  success: boolean,
  results?:  Array<PartitionFilePresence > | null,
  error?: string | null,
};

export type PartitionFilePresence = {
  __typename: "PartitionFilePresence",
  period: string,
  hasFiles?: boolean | null,
  error?: string | null,
};

export type DataHealthResponse = {
  __typename: "DataHealthResponse",
  success: boolean,
  lastSweptAt?: string | null,
  entries?:  Array<DataHealthEntry > | null,
  minPeriod?: string | null,
  maxPeriod?: string | null,
  error?: string | null,
};

export type DataHealthEntry = {
  __typename: "DataHealthEntry",
  period: string,
  verdict: string,
};

export type QueryStatusResponse = {
  __typename: "QueryStatusResponse",
  success: boolean,
  queryExecutionId: string,
  status: string,
  dataScannedBytes?: number | null,
  engineExecutionTimeMillis?: number | null,
  totalExecutionTimeMillis?: number | null,
  error?: string | null,
};

export type QueryResultsResponse = {
  __typename: "QueryResultsResponse",
  success: boolean,
  data: Array< string >,
  queryExecutionId: string,
  nextToken?: string | null,
  hasNextPage: boolean,
  error?: string | null,
};

export type GetRecordInput = {
  tableName: string,
  id: string,
  keyField?: string | null,
};

export type ListRecordsInput = {
  tableName: string,
  filters?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  fetchAll?: boolean | null,
  distinctMode?: DistinctMode | null,
  distinctColumn?: string | null,
};

export enum DistinctMode {
  NONE = "NONE",
  COLUMN_VALUES = "COLUMN_VALUES",
  FULL_ROWS = "FULL_ROWS",
}


export type RecordListResponse = {
  __typename: "RecordListResponse",
  success: boolean,
  data: Array< string >,
  tableName: string,
  totalCount?: number | null,
  nextToken?: string | null,
  error?: string | null,
};

export type GetDependencyDataInput = {
  process: string,
  tableKey: string,
  dependencyTable: string,
  runId: string,
  mode: ConfigMode,
  filters?: ConfigFilters | null,
  page?: ConfigPageInput | null,
  includeSchema?: boolean | null,
  includeColumns?: Array< string > | null,
};

// ---------- Config / dependency chain ----------
export enum ConfigMode {
  VIEW = "VIEW",
  EDIT = "EDIT",
}


export type ConfigFilters = {
  process?: string | null,
  guid?: string | null,
  scenario?: string | null,
  period?: string | null,
};

export type ConfigPageInput = {
  limit?: number | null,
  offset?: number | null,
  nextToken?: string | null,
  resolveGuid?: boolean | null,
  fetchAll?: boolean | null,
};

export type DependencyDataResponse = {
  __typename: "DependencyDataResponse",
  success: boolean,
  data: Array< string >,
  tableName: string,
  dependencyTable: string,
  runId: string,
  guid?: string | null,
  mode: ConfigMode,
  queryExecutionId?: string | null,
  pagination?: PaginationInfo | null,
  nextToken?: string | null,
  error?: string | null,
};

export type PaginationInfo = {
  __typename: "PaginationInfo",
  hasNextPage: boolean,
  totalCount: number,
  pageSize: number,
  currentPage: number,
};

export type GetChartDataInput = {
  outputTable: string,
  actualsTable?: string | null,
  runId: string,
  filters?: string | null,
  forecastFilters?: string | null,
  periodField?: string | null,
  valueField?: string | null,
  actualsValueField?: string | null,
  actualsPeriodField?: string | null,
  actualsGroupBy?: string | null,
  seriesField?: string | null,
  periodStart?: string | null,
  periodEnd?: string | null,
  forceRefresh?: boolean | null,
};

export type ChartDataResponse = {
  __typename: "ChartDataResponse",
  success: boolean,
  forecast: Array< string >,
  actuals: Array< string >,
  forecastQueryId?: string | null,
  actualsQueryId?: string | null,
  error?: string | null,
  errorCode?: string | null,
};

export type GetChartFiltersInput = {
  outputTable: string,
  runId: string,
  columns: Array< string >,
  filters?: string | null,
  forceRefresh?: boolean | null,
};

export type ChartFiltersResponse = {
  __typename: "ChartFiltersResponse",
  success: boolean,
  filterValues: string,
  error?: string | null,
};

export type GetActualsTimeseriesInput = {
  actualsTable: string,
  periodField: string,
  valueField: string,
  filters?: string | null,
  groupBy?: string | null,
  datasetName?: string | null,
  datasetNames?: Array< string > | null,
  scenario?: string | null,
  forceRefresh?: boolean | null,
};

export type ActualsTimeseriesResponse = {
  __typename: "ActualsTimeseriesResponse",
  success: boolean,
  rows: Array< string >,
  queryId?: string | null,
  minPeriod?: string | null,
  maxPeriod?: string | null,
  error?: string | null,
};

export type GetActualsDistinctValuesInput = {
  actualsTable: string,
  periodField: string,
  columns: Array< string >,
  filters?: string | null,
  datasetName?: string | null,
  scenario?: string | null,
  forceRefresh?: boolean | null,
};

export type CheckActualsMembershipInput = {
  actualsTable: string,
  column: string,
  ids: Array< string >,
};

export type CheckActualsMembershipResponse = {
  __typename: "CheckActualsMembershipResponse",
  success: boolean,
  inData?: Array< string > | null,
  error?: string | null,
};

export type GetHierarchyDescendantsInput = {
  datasetGuid: string,
  hierarchyDim: string,
  parentIds: Array< string >,
  topologyOnly?: boolean | null,
  inDataLeaves?: Array< string > | null,
};

export type HierarchyDescendantsResponse = {
  __typename: "HierarchyDescendantsResponse",
  success: boolean,
  descendants: string,
  encoding?: string | null,
  idToName?: string | null,
  idToNameEncoding?: string | null,
  status?: string | null,
  queryExecutionId?: string | null,
  error?: string | null,
};

export type GetHierarchyTopologyStatusInput = {
  datasetGuid: string,
  hierarchyDim: string,
  queryExecutionId: string,
  inDataLeaves?: Array< string > | null,
};

export type SearchDimSumNodesInput = {
  dimensionID: string,
  searchTerm: string,
  size?: number | null,
  from?: number | null,
  includeParents?: boolean | null,
};

export type DimSumSearchResponse = {
  __typename: "DimSumSearchResponse",
  nodes?:  Array<DimSumNode > | null,
  total?: number | null,
  hasMore?: boolean | null,
  parentNodes?:  Array<DimSumNode > | null,
  enabled?: boolean | null,
};

export type DimSumNode = {
  __typename: "DimSumNode",
  id: string,
  nodeID: string,
  name: string,
  description?: string | null,
  keyFull?: Array< string | null > | null,
};

export type DimSumNodesResponse = {
  __typename: "DimSumNodesResponse",
  nodes?:  Array<DimSumNode > | null,
  enabled?: boolean | null,
};

export type GetDimSumChildrenInput = {
  nodeID: string,
  size?: number | null,
  from?: number | null,
};

export type DdbExportStatusResponse = {
  __typename: "DdbExportStatusResponse",
  success: boolean,
  taskId?: string | null,
  status?: string | null,
  rowsWritten?: number | null,
  completedAt?: string | null,
  startedAt?: string | null,
  targetTableName?: string | null,
  error?: string | null,
  errorCode?: string | null,
};

export type DdbExportTaskListResponse = {
  __typename: "DdbExportTaskListResponse",
  success: boolean,
  tasks:  Array<DdbExportTaskRow >,
  error?: string | null,
};

export type DdbExportTaskRow = {
  __typename: "DdbExportTaskRow",
  taskId: string,
  targetTableName: string,
  status: string,
  startedAt?: string | null,
  lastUpdatedAt?: string | null,
  rowsWritten?: number | null,
};

export type CreateViewMutationVariables = {
  input: CreateViewRequest,
};

export type CreateViewMutation = {
  CreateView?:  {
    __typename: "CreateViewResponse",
    id?: string | null,
    error?:  {
      __typename: "ErrorResponse",
      message?: string | null,
    } | null,
  } | null,
};

export type UpdateViewMutationVariables = {
  input: UpdateViewRequest,
};

export type UpdateViewMutation = {
  UpdateView?:  {
    __typename: "UpdateViewResponse",
    id?: string | null,
    error?:  {
      __typename: "ErrorResponse",
      message?: string | null,
    } | null,
  } | null,
};

export type CreateReviewMutationVariables = {
  input: CreateReviewInput,
};

export type CreateReviewMutation = {
  createReview?:  {
    __typename: "StatusOutput",
    status?: string | null,
  } | null,
};

export type CreateSystemMutationVariables = {
  input: CreateSystemInput,
};

export type CreateSystemMutation = {
  createSystem?:  {
    __typename: "StatusOutput",
    status?: string | null,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "StatusOutput",
    status?: string | null,
  } | null,
};

export type AddCommentMutationVariables = {
  input: AddCommentInput,
};

export type AddCommentMutation = {
  addComment?:  {
    __typename: "StatusOutput",
    status?: string | null,
  } | null,
};

export type ManageReviewMutationVariables = {
  input: ManageReviewRequest,
};

export type ManageReviewMutation = {
  manageReview?:  {
    __typename: "StatusOutput",
    status?: string | null,
  } | null,
};

export type ManageReviewerReviewMutationVariables = {
  input: ManageReviewerReviewRequest,
};

export type ManageReviewerReviewMutation = {
  manageReviewerReview?:  {
    __typename: "ManageReviewerReviewResponse",
    status?: string | null,
    review?:  {
      __typename: "ReviewInfo",
      reviewId?: string | null,
      reviewStatus?: ReviewStatus | null,
      reviewJson?: string | null,
      system?: string | null,
      timestamp?: string | null,
      requesterId?: string | null,
      resourceIdentifier?: string | null,
      reviewers?: Array< string | null > | null,
      reviewDescription?: string | null,
      reviewedTimestamp?: string | null,
    } | null,
    reviewStatus?: string | null,
    configStatus?: string | null,
  } | null,
};

export type CreateConfigurationMutationVariables = {
  input: CreateConfigWithReviewInput,
};

export type CreateConfigurationMutation = {
  createConfiguration?:  {
    __typename: "CreateConfigWithReviewOutput",
    reviewStatus?: string | null,
    status?: string | null,
  } | null,
};

export type CreateVersionMutationVariables = {
  input: CreateVersionWithReviewInput,
};

export type CreateVersionMutation = {
  createVersion?:  {
    __typename: "CreateVersionWithReviewOutput",
    reviewStatus?: string | null,
    status?: string | null,
  } | null,
};

export type CreateSandboxMutationVariables = {
  userAlias: string,
  request: CreateSandboxRequest,
};

export type CreateSandboxMutation = {
  // Only ACTIVE resources can be updated
  // Only ACTIVE resources can be deprecated
  // Only ACTIVE resources can be disabled
  // Only ACTIVE resources can be enabled
  // Only ACTIVE resources can be shared
  // Only INACTIVE resources can be revived
  // Shared resources cannot be updated
  // Shared resources can be deprecated
  // Shared resources can be revived
  // Re-Sharing resources overrides all changes by destination sandboxes
  // Only COMPLETED simulations can be shared
  CreateSandbox?:  {
    __typename: "Sandbox",
    sandbox_id: string,
    resource_key: string,
    status_key?: string | null,
    resource_id?: string | null,
    resource_type?: ResourceType | null,
    is_active?: boolean | null,
    created_at?: number | null,
    status?: SandboxStatus | null,
    sandbox_name?: string | null,
    allocation_types?: Array< AllocationType | null > | null,
  } | null,
};

export type UpdateSandboxMutationVariables = {
  userAlias: string,
  sandbox_id: string,
  request: UpdateSandboxRequest,
};

export type UpdateSandboxMutation = {
  UpdateSandbox?:  {
    __typename: "Sandbox",
    sandbox_id: string,
    resource_key: string,
    status_key?: string | null,
    resource_id?: string | null,
    resource_type?: ResourceType | null,
    is_active?: boolean | null,
    created_at?: number | null,
    status?: SandboxStatus | null,
    sandbox_name?: string | null,
    allocation_types?: Array< AllocationType | null > | null,
  } | null,
};

export type DeprecateSandboxMutationVariables = {
  userAlias: string,
  sandbox_id: string,
};

export type DeprecateSandboxMutation = {
  DeprecateSandbox?:  {
    __typename: "Sandbox",
    sandbox_id: string,
    resource_key: string,
    status_key?: string | null,
    resource_id?: string | null,
    resource_type?: ResourceType | null,
    is_active?: boolean | null,
    created_at?: number | null,
    status?: SandboxStatus | null,
    sandbox_name?: string | null,
    allocation_types?: Array< AllocationType | null > | null,
  } | null,
};

export type ReviveSandboxMutationVariables = {
  userAlias: string,
  sandbox_id: string,
};

export type ReviveSandboxMutation = {
  ReviveSandbox?:  {
    __typename: "Sandbox",
    sandbox_id: string,
    resource_key: string,
    status_key?: string | null,
    resource_id?: string | null,
    resource_type?: ResourceType | null,
    is_active?: boolean | null,
    created_at?: number | null,
    status?: SandboxStatus | null,
    sandbox_name?: string | null,
    allocation_types?: Array< AllocationType | null > | null,
  } | null,
};

export type DisableSandboxMutationVariables = {
  userAlias: string,
  sandbox_id: string,
};

export type DisableSandboxMutation = {
  DisableSandbox?:  {
    __typename: "Sandbox",
    sandbox_id: string,
    resource_key: string,
    status_key?: string | null,
    resource_id?: string | null,
    resource_type?: ResourceType | null,
    is_active?: boolean | null,
    created_at?: number | null,
    status?: SandboxStatus | null,
    sandbox_name?: string | null,
    allocation_types?: Array< AllocationType | null > | null,
  } | null,
};

export type EnableSandboxMutationVariables = {
  userAlias: string,
  sandbox_id: string,
};

export type EnableSandboxMutation = {
  EnableSandbox?:  {
    __typename: "Sandbox",
    sandbox_id: string,
    resource_key: string,
    status_key?: string | null,
    resource_id?: string | null,
    resource_type?: ResourceType | null,
    is_active?: boolean | null,
    created_at?: number | null,
    status?: SandboxStatus | null,
    sandbox_name?: string | null,
    allocation_types?: Array< AllocationType | null > | null,
  } | null,
};

export type CreateInputMetadataForSimulationMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  input_type: InputType,
  userAlias: string,
  config?: string | null,
};

export type CreateInputMetadataForSimulationMutation = {
  CreateInputMetadataForSimulation?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type UpdateInputMetadataMutationVariables = {
  s3_path: string,
};

export type UpdateInputMetadataMutation = {
  UpdateInputMetadata?:  Array< {
    __typename: "UserInput",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    created_at: number,
    status: InputStatus,
    input_type: InputType,
    allocation_type: AllocationType,
    s3_path?: string | null,
    userAlias?: string | null,
    dictionary_input_id?: string | null,
    source_id?: string | null,
    source_type?: InputDataSourceType | null,
    configs?: string | null,
    sim_resource_key?: string | null,
  } | null > | null,
};

export type DeprecateInputMutationVariables = {
  sandbox_id: string,
  input_id: string,
};

export type DeprecateInputMutation = {
  DeprecateInput?:  {
    __typename: "UserInput",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    created_at: number,
    status: InputStatus,
    input_type: InputType,
    allocation_type: AllocationType,
    s3_path?: string | null,
    userAlias?: string | null,
    dictionary_input_id?: string | null,
    source_id?: string | null,
    source_type?: InputDataSourceType | null,
    configs?: string | null,
    sim_resource_key?: string | null,
  } | null,
};

export type ReviveInputMutationVariables = {
  sandbox_id: string,
  input_id: string,
};

export type ReviveInputMutation = {
  ReviveInput?:  {
    __typename: "UserInput",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    created_at: number,
    status: InputStatus,
    input_type: InputType,
    allocation_type: AllocationType,
    s3_path?: string | null,
    userAlias?: string | null,
    dictionary_input_id?: string | null,
    source_id?: string | null,
    source_type?: InputDataSourceType | null,
    configs?: string | null,
    sim_resource_key?: string | null,
  } | null,
};

export type CreateLinkInputMutationVariables = {
  userAlias: string,
  s3_path: string,
  sim_id?: string | null,
  sandbox_id: string,
  input_type?: InputType | null,
  name: string,
  configs: string,
};

export type CreateLinkInputMutation = {
  CreateLinkInput?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type CreateSimMutationVariables = {
  sandbox_id: string,
  request: CreateSimRequest,
};

export type CreateSimMutation = {
  CreateSim?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type StartSimMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  userAlias: string,
};

export type StartSimMutation = {
  StartSim?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type ReStartSimMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  userAlias: string,
};

export type ReStartSimMutation = {
  ReStartSim?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type CancelSimMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  userAlias: string,
};

export type CancelSimMutation = {
  CancelSim?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type DeprecateSimMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  is_shared?: boolean | null,
  userAlias: string,
};

export type DeprecateSimMutation = {
  DeprecateSim?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type ReviveSimMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  is_shared?: boolean | null,
  userAlias: string,
};

export type ReviveSimMutation = {
  ReviveSim?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type UpdateSimMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  request: UpdateSimRequest,
};

export type UpdateSimMutation = {
  UpdateSim?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type UpdateSimStatusMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  request: UpdateSimStatusRequest,
};

export type UpdateSimStatusMutation = {
  UpdateSimStatus?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type ShareSimMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  request: ShareSimRequest,
};

export type ShareSimMutation = {
  ShareSim?: string | null,
};

export type ShareSimToRFAMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  userAlias: string,
  comments: string,
  simulation_tag?: string | null,
};

export type ShareSimToRFAMutation = {
  ShareSimToRFA?: string | null,
};

export type UnshareSimFromSandboxMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  request: ShareSimRequest,
};

export type UnshareSimFromSandboxMutation = {
  UnshareSimFromSandbox?: string | null,
};

export type UpdateConfigurationMutationVariables = {
  userAlias: string,
  content: string,
  configType: ConfigType,
};

export type UpdateConfigurationMutation = {
  UpdateConfiguration?:  {
    __typename: "UpdateConfigurationResponse",
    content?: string | null,
  } | null,
};

export type CreateScenarioMutationVariables = {
  userAlias: string,
  request: CreateScenarioRequest,
};

export type CreateScenarioMutation = {
  CreateScenario?:  {
    __typename: "Scenario",
    scenario_name: string,
    start_period: string,
    end_period: string,
    default_public: boolean,
    created_at: number,
    status: ScenarioStatus,
    status_key: string,
    resource_key: string,
    display_period: boolean,
    resource_id: string,
    sandbox_id?: string | null,
    allocation_type?: AllocationType | null,
  } | null,
};

export type UpdateScenarioMutationVariables = {
  userAlias: string,
  request: UpdateScenarioRequest,
};

export type UpdateScenarioMutation = {
  UpdateScenario?:  {
    __typename: "Scenario",
    scenario_name: string,
    start_period: string,
    end_period: string,
    default_public: boolean,
    created_at: number,
    status: ScenarioStatus,
    status_key: string,
    resource_key: string,
    display_period: boolean,
    resource_id: string,
    sandbox_id?: string | null,
    allocation_type?: AllocationType | null,
  } | null,
};

export type EnableScenarioMutationVariables = {
  userAlias: string,
  request: EnableScenarioRequest,
};

export type EnableScenarioMutation = {
  EnableScenario?:  {
    __typename: "Scenario",
    scenario_name: string,
    start_period: string,
    end_period: string,
    default_public: boolean,
    created_at: number,
    status: ScenarioStatus,
    status_key: string,
    resource_key: string,
    display_period: boolean,
    resource_id: string,
    sandbox_id?: string | null,
    allocation_type?: AllocationType | null,
  } | null,
};

export type DisableScenarioMutationVariables = {
  userAlias: string,
  request: DisableScenarioRequest,
};

export type DisableScenarioMutation = {
  DisableScenario?:  {
    __typename: "Scenario",
    scenario_name: string,
    start_period: string,
    end_period: string,
    default_public: boolean,
    created_at: number,
    status: ScenarioStatus,
    status_key: string,
    resource_key: string,
    display_period: boolean,
    resource_id: string,
    sandbox_id?: string | null,
    allocation_type?: AllocationType | null,
  } | null,
};

export type SelectSimulationInputMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  input_type?: InputType | null,
  inputs?: string | null,
  userAlias?: string | null,
};

export type SelectSimulationInputMutation = {
  SelectSimulationInput?: string | null,
};

export type NotifyUploadStatusMutationVariables = {
  sim_id: string,
  metadata_id: string,
  status: UploadStatus,
  validateError?: Array< string | null > | null,
  errorDownloadUrl?: string | null,
};

export type NotifyUploadStatusMutation = {
  NotifyUploadStatus?:  {
    __typename: "UploadStatusType",
    status: UploadStatus,
    validateError?: Array< string | null > | null,
    errorDownloadUrl?: Array< string | null > | null,
  } | null,
};

export type CloneInputDataMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  costpool_ids?: Array< string | null > | null,
  input_reference?: CustomDriverInput | null,
  timePeriod?: Array< string | null > | null,
  userAlias?: string | null,
};

export type CloneInputDataMutation = {
  CloneInputData?: string | null,
};

export type PublishSimMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  userAlias: string,
};

export type PublishSimMutation = {
  PublishSim?: string | null,
};

export type UnpublishSimMutationVariables = {
  sandbox_id: string,
  sim_id: string,
  userAlias: string,
};

export type UnpublishSimMutation = {
  UnpublishSim?: string | null,
};

export type DownloadSimulationInputMutationVariables = {
  input_id: string,
  sandbox_id: string,
  user?: string | null,
  download_type?: DownloadType | null,
};

export type DownloadSimulationInputMutation = {
  DownloadSimulationInput?:  {
    __typename: "GetInputContentDownloadUrlResponse",
    download_url?: string | null,
    error_msg?: string | null,
    status?: DownloadStatus | null,
  } | null,
};

export type StartFileUploadMutationVariables = {
  input: StartFileUploadInput,
};

export type StartFileUploadMutation = {
  StartFileUpload?:  {
    __typename: "StartFileUploadResponse",
    metaDataId: string,
    Url: string,
    message?: string | null,
    status?: UploadStatus | null,
  } | null,
};

export type LinkFileUploadMutationVariables = {
  input: LinkFileUploadInput,
};

export type LinkFileUploadMutation = {
  LinkFileUpload?:  {
    __typename: "LinkFileUploadResponse",
    status: UploadStatus,
    costpoolCount?: number | null,
    message?: string | null,
  } | null,
};

export type NotifyFileUploadStatusMutationVariables = {
  metadataId: string,
  simulationKey: string,
  status: string,
  errors?: Array< string | null > | null,
};

export type NotifyFileUploadStatusMutation = {
  NotifyFileUploadStatus?:  {
    __typename: "FileUploadStatusResponse",
    metadataId: string,
    simulationKey: string,
    status: string,
    errors?: Array< string | null > | null,
  } | null,
};

export type DownloadCostPoolDetailsMutationVariables = {
  costPoolId: string,
  costPoolVersionId: number,
  driverVersionId: number,
};

export type DownloadCostPoolDetailsMutation = {
  DownloadCostPoolDetails?:  {
    __typename: "GetInputContentDownloadUrlResponse",
    download_url?: string | null,
    error_msg?: string | null,
    status?: DownloadStatus | null,
  } | null,
};

export type CancelFileUploadMutationVariables = {
  input: CancelFileUploadInput,
};

export type CancelFileUploadMutation = {
  CancelFileUpload?:  {
    __typename: "CancelFileUploadResponse",
    status: UploadStatus,
    message?: string | null,
  } | null,
};

export type CreateConfigurationInDataStoreMutationVariables = {
  input: CreateConfigurationRequest,
};

export type CreateConfigurationInDataStoreMutation = {
  createConfigurationInDataStore?:  {
    __typename: "CreateConfigurationResponse",
    string?: string | null,
  } | null,
};

export type CreateVersionInDataStoreMutationVariables = {
  input: CreateConfigurationRequest,
};

export type CreateVersionInDataStoreMutation = {
  createVersionInDataStore?:  {
    __typename: "CreateConfigurationResponse",
    string?: string | null,
  } | null,
};

export type CreateTenantMutationVariables = {
  input: CreateTenantRequest,
};

export type CreateTenantMutation = {
  createTenant?:  {
    __typename: "CreateConfigurationResponse",
    string?: string | null,
  } | null,
};

export type ValidateAndExportMutationVariables = {
  input?: ValidateAndExportRequest | null,
};

export type ValidateAndExportMutation = {
  ValidateAndExport?:  {
    __typename: "ValidateAndExportResponse",
    errors?:  Array< {
      __typename: "ErrorDetail",
      rowNumber?: number | null,
      attributeName?: string | null,
      attributeValue?: string | null,
      errorMessage?: string | null,
      suggestion?: string | null,
    } | null > | null,
    dataTarget?:  {
      __typename: "DataTargetDetail",
      dataTargetType?: string | null,
      filePath?: string | null,
    } | null,
    status?: ExportStatus | null,
    message?: string | null,
  } | null,
};

export type CancelStepFunctionMutationVariables = {
  input: CancelStepFunctionRequest,
};

export type CancelStepFunctionMutation = {
  CancelStepFunction?:  {
    __typename: "CancelStepFunctionStatus",
    status?: string | null,
    message?: string | null,
  } | null,
};

export type CreateGFTOneNotificationRequestMutationVariables = {
  input: CreateGFTOneNotificationRequestInput,
};

export type CreateGFTOneNotificationRequestMutation = {
  createGFTOneNotificationRequest?:  {
    __typename: "CreateGFTOneNotificationRequestOutPut",
    allNotifications?:  Array< {
      __typename: "eachNotification",
      id?: string | null,
      app?: string | null,
      channel?: string | null,
      stage?: string | null,
      recipients?: Array< string | null > | null,
      notificationType?: NotificationType | null,
      isSplitGroup?: boolean | null,
      sender?: string | null,
    } | null > | null,
  } | null,
};

export type CreateGFTOneUserSubscriptionMutationVariables = {
  input: CreateGFTOneUserSubscriptionRequest,
};

export type CreateGFTOneUserSubscriptionMutation = {
  createGFTOneUserSubscription?:  {
    __typename: "CreateGFTOneUserSubscriptionResponse",
    id: string,
    status?: string | null,
    app?: string | null,
  } | null,
};

export type DeleteGFTOneUserSubscriptionMutationVariables = {
  input: DeleteGFTOneUserSubscriptionRequest,
};

export type DeleteGFTOneUserSubscriptionMutation = {
  deleteGFTOneUserSubscription?:  {
    __typename: "DeleteGFTOneUserSubscriptionResponse",
    id: string,
    status?: string | null,
  } | null,
};

export type UpdateGFTOneUserSubscriptionMutationVariables = {
  input: UpdateGFTOneUserSubscriptionRequest,
};

export type UpdateGFTOneUserSubscriptionMutation = {
  updateGFTOneUserSubscription?:  {
    __typename: "UpdateGFTOneUserSubscriptionResponse",
    id: string,
    status?: string | null,
  } | null,
};

export type UpdateGFTOneUINotificationMutationVariables = {
  input: UpdateGFTOneUINotificationRequest,
};

export type UpdateGFTOneUINotificationMutation = {
  updateGFTOneUINotification?:  {
    __typename: "UpdateGFTOneUINotificationResponse",
    id: string,
    status?: string | null,
  } | null,
};

export type GetAllGFTOneUINotificationsMutationVariables = {
  input?: GFTOneNotificationsInput | null,
};

export type GetAllGFTOneUINotificationsMutation = {
  getAllGFTOneUINotifications?:  {
    __typename: "getListOfNotifications",
    items?:  Array< {
      __typename: "UINotification",
      id?: string | null,
      app?: string | null,
      channel?: string | null,
      alias?: string | null,
      created_at?: string | null,
      eventType?: string | null,
      stageSystemKey?: string | null,
      seen?: boolean | null,
      read?: boolean | null,
      sender?: string | null,
    } | null > | null,
  } | null,
};

export type CreateResourceMutationVariables = {
  input: CreateBindleResourceRequest,
};

export type CreateResourceMutation = {
  createResource?:  {
    __typename: "CreateBindleResourceResponse",
    resourceID?: string | null,
    status?: string | null,
  } | null,
};

export type CreateFpaoneProductsCatalogMutationVariables = {
  input: CreateFpaoneProductsCatalogInput,
};

export type CreateFpaoneProductsCatalogMutation = {
  createFpaoneProductsCatalog?:  {
    __typename: "FpaoneProductsCatalog",
    category: string,
    productId: string,
    subCategory?: string | null,
    url?: string | null,
    description?: string | null,
    name?: string | null,
    wiki?: string | null,
    productType?: string | null,
    status?: string | null,
    accessGroups?: Array< string | null > | null,
  } | null,
};

export type UpdateFpaoneProductsCatalogMutationVariables = {
  input: UpdateFpaoneProductsCatalogInput,
};

export type UpdateFpaoneProductsCatalogMutation = {
  updateFpaoneProductsCatalog?:  {
    __typename: "FpaoneProductsCatalog",
    category: string,
    productId: string,
    subCategory?: string | null,
    url?: string | null,
    description?: string | null,
    name?: string | null,
    wiki?: string | null,
    productType?: string | null,
    status?: string | null,
    accessGroups?: Array< string | null > | null,
  } | null,
};

export type DeleteFpaoneProductsCatalogMutationVariables = {
  input: DeleteFpaoneProductsCatalogInput,
};

export type DeleteFpaoneProductsCatalogMutation = {
  deleteFpaoneProductsCatalog?:  {
    __typename: "FpaoneProductsCatalog",
    category: string,
    productId: string,
    subCategory?: string | null,
    url?: string | null,
    description?: string | null,
    name?: string | null,
    wiki?: string | null,
    productType?: string | null,
    status?: string | null,
    accessGroups?: Array< string | null > | null,
  } | null,
};

export type CreateUserWorkspaceDetailsMutationVariables = {
  input: CreateUserWorkspaceDetailsInput,
};

export type CreateUserWorkspaceDetailsMutation = {
  createUserWorkspaceDetails?:  {
    __typename: "UserWorkspaceDetails",
    userId: string,
    productIds?: Array< string | null > | null,
  } | null,
};

export type UpdateUserWorkspaceDetailsMutationVariables = {
  input: UpdateUserWorkspaceDetailsInput,
};

export type UpdateUserWorkspaceDetailsMutation = {
  updateUserWorkspaceDetails?:  {
    __typename: "UserWorkspaceDetails",
    userId: string,
    productIds?: Array< string | null > | null,
  } | null,
};

export type DeleteUserWorkspaceDetailsMutationVariables = {
  input: DeleteUserWorkspaceDetailsInput,
};

export type DeleteUserWorkspaceDetailsMutation = {
  deleteUserWorkspaceDetails?:  {
    __typename: "UserWorkspaceDetails",
    userId: string,
    productIds?: Array< string | null > | null,
  } | null,
};

export type CreateFPAOneTicketMutationVariables = {
  input: TicketInput,
};

export type CreateFPAOneTicketMutation = {
  createFPAOneTicket?:  {
    __typename: "TicketyResponseDetails",
    ticketyId: string,
  } | null,
};

export type CreateTicketMutationVariables = {
  input: CreateTicketInput,
};

export type CreateTicketMutation = {
  createTicket?:  {
    __typename: "TicketyResponseDetails",
    ticketyId: string,
  } | null,
};

export type CreateProductMutationVariables = {
  input: CreateProductInput,
};

export type CreateProductMutation = {
  createProduct?:  {
    __typename: "ProductDetails",
    productId: string,
    name: string,
    description: string,
    info?: string | null,
    alias?: string | null,
    subCategoryId: string,
    subCategoryName: string,
    categoryId?: string | null,
    categoryName?: string | null,
    status: StatusType,
    productType: ProductType,
    accessGroups: Array< string >,
    ownerGroups?: Array< string > | null,
    QUICKSIGHT_DASHBOARD?:  {
      __typename: "ProductConfigQuicksight",
      accountId?: string | null,
      namespace?: string | null,
      dashboardId?: string | null,
      props?: string | null,
    } | null,
    APLIQO_DASHBOARD?:  {
      __typename: "ProductConfigApliqo",
      url?: string | null,
      props?: string | null,
    } | null,
    MICRO_FRONTEND?:  {
      __typename: "ProductConfigMicroFrontend",
      filePath?: string | null,
      exportApp?: string | null,
      props?: string | null,
    } | null,
    NATIVE_EXTERNAL?:  {
      __typename: "ProductConfigExternal",
      url?: string | null,
      props?: string | null,
    } | null,
    NATIVE_INTERNAL?:  {
      __typename: "ProductConfigInternal",
      name?: string | null,
      props?: string | null,
    } | null,
    accessType: ProductsAccessType,
    fintalkEnabled?: boolean | null,
    fintalkProps?: string | null,
    requestAccessLink?: string | null,
    featured?: number | null,
    wiki?: string | null,
    poc: string,
    ticketConfig?:  {
      __typename: "ProductTicketConfig",
      category?: string | null,
      type?: string | null,
    } | null,
    createdAt: string,
    createdBy: string,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type UpdateProductMutationVariables = {
  input: UpdateProductInput,
};

export type UpdateProductMutation = {
  updateProduct?:  {
    __typename: "ProductDetails",
    productId: string,
    name: string,
    description: string,
    info?: string | null,
    alias?: string | null,
    subCategoryId: string,
    subCategoryName: string,
    categoryId?: string | null,
    categoryName?: string | null,
    status: StatusType,
    productType: ProductType,
    accessGroups: Array< string >,
    ownerGroups?: Array< string > | null,
    QUICKSIGHT_DASHBOARD?:  {
      __typename: "ProductConfigQuicksight",
      accountId?: string | null,
      namespace?: string | null,
      dashboardId?: string | null,
      props?: string | null,
    } | null,
    APLIQO_DASHBOARD?:  {
      __typename: "ProductConfigApliqo",
      url?: string | null,
      props?: string | null,
    } | null,
    MICRO_FRONTEND?:  {
      __typename: "ProductConfigMicroFrontend",
      filePath?: string | null,
      exportApp?: string | null,
      props?: string | null,
    } | null,
    NATIVE_EXTERNAL?:  {
      __typename: "ProductConfigExternal",
      url?: string | null,
      props?: string | null,
    } | null,
    NATIVE_INTERNAL?:  {
      __typename: "ProductConfigInternal",
      name?: string | null,
      props?: string | null,
    } | null,
    accessType: ProductsAccessType,
    fintalkEnabled?: boolean | null,
    fintalkProps?: string | null,
    requestAccessLink?: string | null,
    featured?: number | null,
    wiki?: string | null,
    poc: string,
    ticketConfig?:  {
      __typename: "ProductTicketConfig",
      category?: string | null,
      type?: string | null,
    } | null,
    createdAt: string,
    createdBy: string,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type CreateCategoryMutationVariables = {
  input: CreateCategoryInput,
};

export type CreateCategoryMutation = {
  createCategory?:  {
    __typename: "CategoryDetails",
    categoryId: string,
    categoryName: string,
    status: StatusType,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type UpdateCategoryMutationVariables = {
  input: UpdateCategoryInput,
};

export type UpdateCategoryMutation = {
  updateCategory?:  {
    __typename: "CategoryDetails",
    categoryId: string,
    categoryName: string,
    status: StatusType,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type CreateSubCategoryMutationVariables = {
  input: CreateSubCategoryInput,
};

export type CreateSubCategoryMutation = {
  createSubCategory?:  {
    __typename: "SubCategoryDetails",
    subCategoryId: string,
    subCategoryName: string,
    parentCategoryId: string,
    status: StatusType,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type UpdateSubCategoryMutationVariables = {
  input: UpdateSubCategoryInput,
};

export type UpdateSubCategoryMutation = {
  updateSubCategory?:  {
    __typename: "SubCategoryDetails",
    subCategoryId: string,
    subCategoryName: string,
    parentCategoryId: string,
    status: StatusType,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type CreateSectionMutationVariables = {
  input: CreateResourcesSectionInput,
};

export type CreateSectionMutation = {
  createSection?:  {
    __typename: "ResourcesSection",
    sectionId: string,
    sectionName: string,
    status?: StatusType | null,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    subsections?:  Array< {
      __typename: "ResourcesSubsection",
      subsectionId: string,
      subsectionName: string,
      description?: string | null,
      wikiLink?: string | null,
      contentURL?: string | null,
      parentSectionId: string,
      status?: StatusType | null,
      sortOrder?: number | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null > | null,
  } | null,
};

export type CreateSubsectionMutationVariables = {
  input: CreateResourcesSubsectionInput,
};

export type CreateSubsectionMutation = {
  createSubsection?:  {
    __typename: "ResourcesSubsection",
    subsectionId: string,
    subsectionName: string,
    description?: string | null,
    wikiLink?: string | null,
    contentURL?: string | null,
    parentSectionId: string,
    status?: StatusType | null,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type UpdateSectionMutationVariables = {
  input: UpdateResourcesSectionInput,
};

export type UpdateSectionMutation = {
  updateSection?:  {
    __typename: "ResourcesSection",
    sectionId: string,
    sectionName: string,
    status?: StatusType | null,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    subsections?:  Array< {
      __typename: "ResourcesSubsection",
      subsectionId: string,
      subsectionName: string,
      description?: string | null,
      wikiLink?: string | null,
      contentURL?: string | null,
      parentSectionId: string,
      status?: StatusType | null,
      sortOrder?: number | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null > | null,
  } | null,
};

export type UpdateSubsectionMutationVariables = {
  input: UpdateResourcesSubsectionInput,
};

export type UpdateSubsectionMutation = {
  updateSubsection?:  {
    __typename: "ResourcesSubsection",
    subsectionId: string,
    subsectionName: string,
    description?: string | null,
    wikiLink?: string | null,
    contentURL?: string | null,
    parentSectionId: string,
    status?: StatusType | null,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type UpdateAboutFPAOneMutationVariables = {
  input: UpdateAboutFPAOneInput,
};

export type UpdateAboutFPAOneMutation = {
  updateAboutFPAOne?:  {
    __typename: "AboutFPAOne",
    aboutId: string,
    about: string,
    poc: Array< string >,
    accessGroups: Array< string >,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type CreateTicketForProductMutationVariables = {
  input: CreateTicketForProductInput,
};

export type CreateTicketForProductMutation = {
  createTicketForProduct?:  {
    __typename: "TicketyResponseDetails",
    ticketyId: string,
  } | null,
};

export type UpdateFederateMappingMutationVariables = {
  input: UpdateFederateMappingInput,
};

export type UpdateFederateMappingMutation = {
  updateFederateMapping?:  {
    __typename: "FederateMapperResponse",
    success: boolean,
    message?: string | null,
  } | null,
};

export type StartConfigQueryMutationVariables = {
  input: StartConfigQueryInput,
};

export type StartConfigQueryMutation = {
  startConfigQuery:  {
    __typename: "StartQueryResponse",
    success: boolean,
    queryExecutionId?: string | null,
    countQueryExecutionId?: string | null,
    minPeriod?: string | null,
    maxPeriod?: string | null,
    error?: string | null,
    data?: string | null,
  },
};

export type CreateRecordMutationVariables = {
  input: CreateRecordInput,
};

export type CreateRecordMutation = {
  createRecord:  {
    __typename: "RecordResponse",
    success: boolean,
    message: string,
    data?: string | null,
    tableName: string,
    recordId?: string | null,
    error?: string | null,
    // Optional outcome of the BE update post-processor side-effect (e.g.
    // Kinesis approval-event publish for cashflow). Tri-valued via
    // presence: omitted when no side-effect ran (most processes / writes),
    // ``true`` on a successful publish, ``false`` on a failed publish.
    // The FE reads this on ``updateRecord`` to append a "Notification
    // sent" clause to the success banner — see ``RunDetails.tsx``.
    notificationsPublished?: boolean | null,
  },
};

export type UpdateRecordMutationVariables = {
  input: UpdateRecordInput,
};

export type UpdateRecordMutation = {
  updateRecord:  {
    __typename: "RecordResponse",
    success: boolean,
    message: string,
    data?: string | null,
    tableName: string,
    recordId?: string | null,
    error?: string | null,
    // Optional outcome of the BE update post-processor side-effect (e.g.
    // Kinesis approval-event publish for cashflow). Tri-valued via
    // presence: omitted when no side-effect ran (most processes / writes),
    // ``true`` on a successful publish, ``false`` on a failed publish.
    // The FE reads this on ``updateRecord`` to append a "Notification
    // sent" clause to the success banner — see ``RunDetails.tsx``.
    notificationsPublished?: boolean | null,
  },
};

export type DeleteRecordMutationVariables = {
  input: DeleteRecordInput,
};

export type DeleteRecordMutation = {
  deleteRecord:  {
    __typename: "RecordResponse",
    success: boolean,
    message: string,
    data?: string | null,
    tableName: string,
    recordId?: string | null,
    error?: string | null,
    // Optional outcome of the BE update post-processor side-effect (e.g.
    // Kinesis approval-event publish for cashflow). Tri-valued via
    // presence: omitted when no side-effect ran (most processes / writes),
    // ``true`` on a successful publish, ``false`` on a failed publish.
    // The FE reads this on ``updateRecord`` to append a "Notification
    // sent" clause to the success banner — see ``RunDetails.tsx``.
    notificationsPublished?: boolean | null,
  },
};

export type GenerateNewRunModularMutationVariables = {
  input: GenerateNewRunModularInput,
};

export type GenerateNewRunModularMutation = {
  generateNewRunModular:  {
    __typename: "GenerateNewRunResponse",
    success: boolean,
    message?: string | null,
    runId?: string | null,
    data?: string | null,
    error?: string | null,
  },
};

export type ExportDynamoToS3MutationVariables = {
  tableName: string,
};

export type ExportDynamoToS3Mutation = {
  exportDynamoToS3:  {
    __typename: "ExportDynamoToS3Response",
    success: boolean,
    message: string,
    runId?: string | null,
    data?: string | null,
    error?: string | null,
  },
};

export type PrecomputeChartDependencyMutationVariables = {
  input: PrecomputeChartDependencyInput,
};

export type PrecomputeChartDependencyMutation = {
  precomputeChartDependency:  {
    __typename: "MutationResponse",
    success: boolean,
    data?: string | null,
    error?: string | null,
  },
};

export type ExportForecastToS3MutationVariables = {
  input: ExportForecastToS3Input,
};

export type ExportForecastToS3Mutation = {
  exportForecastToS3:  {
    __typename: "ExportForecastResponse",
    success: boolean,
    presignedUrl?: string | null,
    fileName: string,
    expiresAt?: string | null,
    recordCount: number,
    data?: string | null,
    error?: string | null,
  },
};

export type ExportActualsToS3MutationVariables = {
  input: ExportActualsToS3Input,
};

export type ExportActualsToS3Mutation = {
  exportActualsToS3:  {
    __typename: "ExportForecastResponse",
    success: boolean,
    presignedUrl?: string | null,
    fileName: string,
    expiresAt?: string | null,
    recordCount: number,
    data?: string | null,
    error?: string | null,
  },
};

export type ComputeHierarchicalRollupMutationVariables = {
  input: ComputeHierarchicalRollupInput,
};

export type ComputeHierarchicalRollupMutation = {
  computeHierarchicalRollup:  {
    __typename: "ComputeHierarchicalRollupResponse",
    success: boolean,
    data?: string | null,
    queryExecutionId?: string | null,
    error?: string | null,
  },
};

export type PresignQueryResultMutationVariables = {
  input: PresignQueryResultInput,
};

export type PresignQueryResultMutation = {
  presignQueryResult:  {
    __typename: "PresignQueryResultResponse",
    success: boolean,
    presignedUrl?: string | null,
    fileName: string,
    expiresAt?: string | null,
    recordCount: number,
    data?: string | null,
    error?: string | null,
  },
};

export type PutDrrApprovalCsvMutationVariables = {
  input: PutDrrApprovalCsvInput,
};

export type PutDrrApprovalCsvMutation = {
  putDrrApprovalCsv:  {
    __typename: "PutDrrApprovalCsvResponse",
    success: boolean,
    bucket?: string | null,
    key?: string | null,
    error?: string | null,
  },
};

export type WriteAthenaResultToDynamoMutationVariables = {
  input: WriteAthenaResultToDynamoInput,
};

export type WriteAthenaResultToDynamoMutation = {
  writeAthenaResultToDynamo:  {
    __typename: "WriteAthenaResultToDynamoResponse",
    success: boolean,
    taskId?: string | null,
    errorCode?: string | null,
    data?: string | null,
    error?: string | null,
  },
};

export type GetSyncStatusQueryVariables = {
};

export type GetSyncStatusQuery = {
  GetSyncStatus?:  {
    __typename: "GetSyncStatusResponse",
    statusCode?: number | null,
    data?:  {
      __typename: "SyncStatus",
    } | null,
  } | null,
};

export type IsAuthorizedToAccessServiceQueryVariables = {
  input: IsAuthorizedRequest,
};

export type IsAuthorizedToAccessServiceQuery = {
  IsAuthorizedToAccessService?:  {
    __typename: "IsAuthorizedResponse",
    isAuthorized?: boolean | null,
  } | null,
};

export type GetDashboardEmbedUrlQueryVariables = {
  input: GetDashboardEmbedUrlRequest,
};

export type GetDashboardEmbedUrlQuery = {
  GetDashboardEmbedUrl?:  {
    __typename: "GetDashboardEmbedUrlResponse",
    url?: string | null,
    error?:  {
      __typename: "ErrorResponse",
      message?: string | null,
    } | null,
  } | null,
};

export type GetUserServiceAccessQueryVariables = {
  input?: GetUserServiceAccessRequest | null,
};

export type GetUserServiceAccessQuery = {
  GetUserServiceAccess?:  {
    __typename: "GetUserServiceAccessResponse",
    services?:  Array< {
      __typename: "UserServiceAccess",
      name?: string | null,
    } | null > | null,
  } | null,
};

export type LoadFilterOptionsQueryVariables = {
  input: GetLoadFilterOptionsRequest,
};

export type LoadFilterOptionsQuery = {
  LoadFilterOptions?:  {
    __typename: "GetLoadFilterOptionsResponse",
    filters?: string | null,
    error?:  {
      __typename: "ErrorResponse",
      message?: string | null,
    } | null,
  } | null,
};

export type RetrieveViewQueryVariables = {
  input: GetRetrieveViewRequest,
};

export type RetrieveViewQuery = {
  RetrieveView?:  {
    __typename: "GetRetrieveViewResponse",
    viewData?: string | null,
    error?:  {
      __typename: "ErrorResponse",
      message?: string | null,
    } | null,
  } | null,
};

export type LoadSavedViewsListQueryVariables = {
  input: LoadSavedViewsListRequest,
};

export type LoadSavedViewsListQuery = {
  LoadSavedViewsList?:  {
    __typename: "LoadSavedViewsListResponse",
    Views?:  Array< {
      __typename: "ViewItem",
      viewData?: string | null,
    } | null > | null,
    error?:  {
      __typename: "ErrorResponse",
      message?: string | null,
    } | null,
  } | null,
};

export type FetchReviewsQueryVariables = {
  input: FetchReviewsRequest,
};

export type FetchReviewsQuery = {
  fetchReviews?:  {
    __typename: "FetchReviewsResponse",
    reviews?:  Array< {
      __typename: "ReviewInfo",
      reviewId?: string | null,
      reviewStatus?: ReviewStatus | null,
      reviewJson?: string | null,
      system?: string | null,
      timestamp?: string | null,
      requesterId?: string | null,
      resourceIdentifier?: string | null,
      reviewers?: Array< string | null > | null,
      reviewDescription?: string | null,
      reviewedTimestamp?: string | null,
    } | null > | null,
  } | null,
};

export type FetchReviewsByUserQueryVariables = {
  input: FetchReviewsByUserRequest,
};

export type FetchReviewsByUserQuery = {
  fetchReviewsByUser?:  {
    __typename: "FetchReviewsByUserResponse",
    reviewsRequestedByUser?:  Array< {
      __typename: "ReviewInfo",
      reviewId?: string | null,
      reviewStatus?: ReviewStatus | null,
      reviewJson?: string | null,
      system?: string | null,
      timestamp?: string | null,
      requesterId?: string | null,
      resourceIdentifier?: string | null,
      reviewers?: Array< string | null > | null,
      reviewDescription?: string | null,
      reviewedTimestamp?: string | null,
    } | null > | null,
    reviewsToBeReviewedByUser?:  Array< {
      __typename: "ReviewInfo",
      reviewId?: string | null,
      reviewStatus?: ReviewStatus | null,
      reviewJson?: string | null,
      system?: string | null,
      timestamp?: string | null,
      requesterId?: string | null,
      resourceIdentifier?: string | null,
      reviewers?: Array< string | null > | null,
      reviewDescription?: string | null,
      reviewedTimestamp?: string | null,
    } | null > | null,
  } | null,
};

export type CheckSystemPermissionQueryVariables = {
  input: CheckSystemPermissionInput,
};

export type CheckSystemPermissionQuery = {
  checkSystemPermission?:  {
    __typename: "CheckSystemPermissionOutput",
    hasAccess?: boolean | null,
  } | null,
};

export type FetchReviewByIdQueryVariables = {
  input: FetchReviewByIdRequest,
};

export type FetchReviewByIdQuery = {
  fetchReviewById?:  {
    __typename: "FetchReviewByIdResponse",
    review?:  {
      __typename: "ReviewInfo",
      reviewId?: string | null,
      reviewStatus?: ReviewStatus | null,
      reviewJson?: string | null,
      system?: string | null,
      timestamp?: string | null,
      requesterId?: string | null,
      resourceIdentifier?: string | null,
      reviewers?: Array< string | null > | null,
      reviewDescription?: string | null,
      reviewedTimestamp?: string | null,
    } | null,
  } | null,
};

export type FetchAccessibleReviewsQueryVariables = {
  input?: FetchReviewsRequest | null,
};

export type FetchAccessibleReviewsQuery = {
  fetchAccessibleReviews?:  {
    __typename: "FetchReviewsResponse",
    reviews?:  Array< {
      __typename: "ReviewInfo",
      reviewId?: string | null,
      reviewStatus?: ReviewStatus | null,
      reviewJson?: string | null,
      system?: string | null,
      timestamp?: string | null,
      requesterId?: string | null,
      resourceIdentifier?: string | null,
      reviewers?: Array< string | null > | null,
      reviewDescription?: string | null,
      reviewedTimestamp?: string | null,
    } | null > | null,
  } | null,
};

export type CreateSIMTicketQueryVariables = {
  input: CreateSIMTicketRequest,
};

export type CreateSIMTicketQuery = {
  createSIMTicket?:  {
    __typename: "CreateSIMTicketResponse",
    ticketID?: string | null,
  } | null,
};

export type GetGroupsUserIsMemberOfQueryVariables = {
  userAlias: string,
};

export type GetGroupsUserIsMemberOfQuery = {
  GetGroupsUserIsMemberOf?:  {
    __typename: "SandboxGroupMembership",
    is_super_admin: boolean,
    member_of_groups?: Array< string | null > | null,
    sandboxes_accessible?:  Array< {
      __typename: "UserSandboxAccess",
      sandbox_id: string,
      sandbox_name: string,
      status?: SandboxStatus | null,
      allocation_types?: Array< AllocationType | null > | null,
      is_active: boolean,
      created_at?: number | null,
    } | null > | null,
  } | null,
};

export type ListSandboxWithAclQueryVariables = {
  userAlias: string,
};

export type ListSandboxWithAclQuery = {
  ListSandboxWithAcl?:  {
    __typename: "SandboxGroupMembership",
    is_super_admin: boolean,
    member_of_groups?: Array< string | null > | null,
    sandboxes_accessible?:  Array< {
      __typename: "UserSandboxAccess",
      sandbox_id: string,
      sandbox_name: string,
      status?: SandboxStatus | null,
      allocation_types?: Array< AllocationType | null > | null,
      is_active: boolean,
      created_at?: number | null,
    } | null > | null,
  } | null,
};

export type CheckAdminRoleQueryVariables = {
  userAlias: string,
};

export type CheckAdminRoleQuery = {
  CheckAdminRole?:  {
    __typename: "isAdminResponse",
    is_admin: boolean,
  } | null,
};

export type GetSandboxQueryVariables = {
  userAlias: string,
  sandbox_id: string,
  is_active?: boolean | null,
};

export type GetSandboxQuery = {
  GetSandbox?:  {
    __typename: "Sandbox",
    sandbox_id: string,
    resource_key: string,
    status_key?: string | null,
    resource_id?: string | null,
    resource_type?: ResourceType | null,
    is_active?: boolean | null,
    created_at?: number | null,
    status?: SandboxStatus | null,
    sandbox_name?: string | null,
    allocation_types?: Array< AllocationType | null > | null,
  } | null,
};

export type ListSandboxesQueryVariables = {
  userAlias: string,
  is_active?: boolean | null,
  filter?: TableSandboxFilterRequest | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSandboxesQuery = {
  ListSandboxes?:  {
    __typename: "SandboxListPage",
    items?:  Array< {
      __typename: "Sandbox",
      sandbox_id: string,
      resource_key: string,
      status_key?: string | null,
      resource_id?: string | null,
      resource_type?: ResourceType | null,
      is_active?: boolean | null,
      created_at?: number | null,
      status?: SandboxStatus | null,
      sandbox_name?: string | null,
      allocation_types?: Array< AllocationType | null > | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetInputContentQueryVariables = {
  sandbox_id: string,
  input_id: string,
  allocation_pool_filters?: Array< string | null > | null,
  limit?: number | null,
  offset?: number | null,
};

export type GetInputContentQuery = {
  GetInputContent?:  {
    __typename: "GetAllocationConfigContentResponse",
    content?: string | null,
    last_modified?: string | null,
  } | null,
};

export type GetInputContentDownloadUrlQueryVariables = {
  sandbox_id: string,
  input_id: string,
  allocation_pool_filters?: Array< string | null > | null,
  user: string,
  file_name: string,
};

export type GetInputContentDownloadUrlQuery = {
  GetInputContentDownloadUrl?:  {
    __typename: "GetInputContentDownloadUrlResponse",
    download_url?: string | null,
    error_msg?: string | null,
    status?: DownloadStatus | null,
  } | null,
};

export type GetInputSchemaQueryVariables = {
  allocation_type: AllocationType,
  input_type: InputType,
  sandbox_id?: string | null,
  input_id?: string | null,
};

export type GetInputSchemaQuery = {
  GetInputSchema?:  {
    __typename: "AllocationConfigSchema",
    column_schema?:  Array< {
      __typename: "AllocationConfigSchemaColumn",
      name?: string | null,
      label?: string | null,
      type?: string | null,
      required?: boolean | null,
      defaultValue?: string | null,
    } | null > | null,
    query_schema?: string | null,
  } | null,
};

export type ListInputQueryVariables = {
  sandbox_id: string,
  is_active?: boolean | null,
  allocation_type?: AllocationType | null,
  input_type?: InputType | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInputQuery = {
  ListInput?:  {
    __typename: "InputListPage",
    items?:  Array< {
      __typename: "UserInput",
      sandbox_id: string,
      resource_key: string,
      status_key: string,
      resource_id: string,
      resource_type: ResourceType,
      is_active: boolean,
      created_at: number,
      status: InputStatus,
      input_type: InputType,
      allocation_type: AllocationType,
      s3_path?: string | null,
      userAlias?: string | null,
      dictionary_input_id?: string | null,
      source_id?: string | null,
      source_type?: InputDataSourceType | null,
      configs?: string | null,
      sim_resource_key?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAllocationConfigContentQueryVariables = {
  allocation_type: AllocationType,
  input_type: InputType,
  sandbox_id?: string | null,
  input_id?: string | null,
  allocation_pool_filters?: Array< string | null > | null,
  limit?: number | null,
  offset?: number | null,
  group_by?: string | null,
  userAlias?: string | null,
};

export type GetAllocationConfigContentQuery = {
  GetAllocationConfigContent?:  {
    __typename: "GetAllocationConfigContentResponse",
    content?: string | null,
    last_modified?: string | null,
  } | null,
};

export type GetAllocationConfigSchemaQueryVariables = {
  allocation_type: AllocationType,
  input_type: InputType,
  sandbox_id?: string | null,
  input_id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllocationConfigSchemaQuery = {
  GetAllocationConfigSchema?:  {
    __typename: "AllocationConfigSchema",
    column_schema?:  Array< {
      __typename: "AllocationConfigSchemaColumn",
      name?: string | null,
      label?: string | null,
      type?: string | null,
      required?: boolean | null,
      defaultValue?: string | null,
    } | null > | null,
    query_schema?: string | null,
  } | null,
};

export type ListInputDictionaryDiffQueryVariables = {
  sandbox_id: string,
  input_id: string,
  limit?: number | null,
  start?: number | null,
  use_dictionary_schema?: boolean | null,
};

export type ListInputDictionaryDiffQuery = {
  ListInputDictionaryDiff?:  {
    __typename: "InputDictionaryDiff",
    input_json?: string | null,
    input_schema?:  Array< {
      __typename: "AllocationConfigSchemaColumn",
      name?: string | null,
      label?: string | null,
      type?: string | null,
      required?: boolean | null,
      defaultValue?: string | null,
    } > | null,
    total_input_count?: number | null,
    diff?: string | null,
    userAlias?: string | null,
    created_at: number,
  } | null,
};

export type GetSimDetailsQueryVariables = {
  sandbox_id: string,
  sim_id: string,
  is_active?: boolean | null,
  is_shared?: boolean | null,
};

export type GetSimDetailsQuery = {
  GetSimDetails?:  {
    __typename: "Sim",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    name?: string | null,
    status: SimStatus,
    created_at: number,
    updated_at?: number | null,
    started_at?: number | null,
    finished_at?: number | null,
    error_msg?: string | null,
    configs?: string | null,
    allocation_type: AllocationType,
    input_ids?: Array< string | null > | null,
    mwaa_env?: string | null,
    dag_run_id?: string | null,
    scenario?: string | null,
    // Using string instead of enum to support names like "R&O Current", without having to map manually
    timeRange?: Array< string | null > | null,
    dag_tasks_status?: string | null,
    // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
    report_id?: string | null,
    is_shared?: boolean | null,
    userAlias: string,
    created_by?: string | null,
    updated_by?: string | null,
    started_by?: string | null,
    is_input_selected?: boolean | null,
    published_to_fpaone?: boolean | null,
    fpaone_publish_status?: string | null,
    sandbox_name?: string | null,
    shared_to_sandbox_ids?: Array< string | null > | null,
    shared_from_sandbox_id?: string | null,
    shared_from_sandbox_name?: string | null,
    comments?: string | null,
    allocation_pools?: string | null,
    ticket_id?: string | null,
    simulation_tag?: string | null,
  } | null,
};

export type ListSimsBySandboxQueryVariables = {
  sandbox_id: string,
  is_active?: boolean | null,
  is_shared?: boolean | null,
  is_shared_by_me?: boolean | null,
  filter?: SimBySandboxIdStatusFilterRequest | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSimsBySandboxQuery = {
  ListSimsBySandbox?:  {
    __typename: "SimListPage",
    items?:  Array< {
      __typename: "Sim",
      sandbox_id: string,
      resource_key: string,
      status_key: string,
      resource_id: string,
      resource_type: ResourceType,
      is_active: boolean,
      name?: string | null,
      status: SimStatus,
      created_at: number,
      updated_at?: number | null,
      started_at?: number | null,
      finished_at?: number | null,
      error_msg?: string | null,
      configs?: string | null,
      allocation_type: AllocationType,
      input_ids?: Array< string | null > | null,
      mwaa_env?: string | null,
      dag_run_id?: string | null,
      scenario?: string | null,
      // Using string instead of enum to support names like "R&O Current", without having to map manually
      timeRange?: Array< string | null > | null,
      dag_tasks_status?: string | null,
      // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
      report_id?: string | null,
      is_shared?: boolean | null,
      userAlias: string,
      created_by?: string | null,
      updated_by?: string | null,
      started_by?: string | null,
      is_input_selected?: boolean | null,
      published_to_fpaone?: boolean | null,
      fpaone_publish_status?: string | null,
      sandbox_name?: string | null,
      shared_to_sandbox_ids?: Array< string | null > | null,
      shared_from_sandbox_id?: string | null,
      shared_from_sandbox_name?: string | null,
      comments?: string | null,
      allocation_pools?: string | null,
      ticket_id?: string | null,
      simulation_tag?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListAllSimsQueryVariables = {
  is_active?: boolean | null,
  filter?: SimBySandboxIdStatusFilterRequest | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAllSimsQuery = {
  ListAllSims?:  {
    __typename: "SimListPage",
    items?:  Array< {
      __typename: "Sim",
      sandbox_id: string,
      resource_key: string,
      status_key: string,
      resource_id: string,
      resource_type: ResourceType,
      is_active: boolean,
      name?: string | null,
      status: SimStatus,
      created_at: number,
      updated_at?: number | null,
      started_at?: number | null,
      finished_at?: number | null,
      error_msg?: string | null,
      configs?: string | null,
      allocation_type: AllocationType,
      input_ids?: Array< string | null > | null,
      mwaa_env?: string | null,
      dag_run_id?: string | null,
      scenario?: string | null,
      // Using string instead of enum to support names like "R&O Current", without having to map manually
      timeRange?: Array< string | null > | null,
      dag_tasks_status?: string | null,
      // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
      report_id?: string | null,
      is_shared?: boolean | null,
      userAlias: string,
      created_by?: string | null,
      updated_by?: string | null,
      started_by?: string | null,
      is_input_selected?: boolean | null,
      published_to_fpaone?: boolean | null,
      fpaone_publish_status?: string | null,
      sandbox_name?: string | null,
      shared_to_sandbox_ids?: Array< string | null > | null,
      shared_from_sandbox_id?: string | null,
      shared_from_sandbox_name?: string | null,
      comments?: string | null,
      allocation_pools?: string | null,
      ticket_id?: string | null,
      simulation_tag?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListSimsByStatusBySandboxQueryVariables = {
  sandbox_id: string,
  is_active?: boolean | null,
  is_shared?: boolean | null,
  status: SimStatus,
  filter?: SimBySandboxIdStatusFilterRequest | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSimsByStatusBySandboxQuery = {
  ListSimsByStatusBySandbox?:  {
    __typename: "SimListPage",
    items?:  Array< {
      __typename: "Sim",
      sandbox_id: string,
      resource_key: string,
      status_key: string,
      resource_id: string,
      resource_type: ResourceType,
      is_active: boolean,
      name?: string | null,
      status: SimStatus,
      created_at: number,
      updated_at?: number | null,
      started_at?: number | null,
      finished_at?: number | null,
      error_msg?: string | null,
      configs?: string | null,
      allocation_type: AllocationType,
      input_ids?: Array< string | null > | null,
      mwaa_env?: string | null,
      dag_run_id?: string | null,
      scenario?: string | null,
      // Using string instead of enum to support names like "R&O Current", without having to map manually
      timeRange?: Array< string | null > | null,
      dag_tasks_status?: string | null,
      // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
      report_id?: string | null,
      is_shared?: boolean | null,
      userAlias: string,
      created_by?: string | null,
      updated_by?: string | null,
      started_by?: string | null,
      is_input_selected?: boolean | null,
      published_to_fpaone?: boolean | null,
      fpaone_publish_status?: string | null,
      sandbox_name?: string | null,
      shared_to_sandbox_ids?: Array< string | null > | null,
      shared_from_sandbox_id?: string | null,
      shared_from_sandbox_name?: string | null,
      comments?: string | null,
      allocation_pools?: string | null,
      ticket_id?: string | null,
      simulation_tag?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListSimsByStatusQueryVariables = {
  is_active?: boolean | null,
  status: SimStatus,
  filter?: SimBySandboxIdStatusFilterRequest | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSimsByStatusQuery = {
  ListSimsByStatus?:  {
    __typename: "SimListPage",
    items?:  Array< {
      __typename: "Sim",
      sandbox_id: string,
      resource_key: string,
      status_key: string,
      resource_id: string,
      resource_type: ResourceType,
      is_active: boolean,
      name?: string | null,
      status: SimStatus,
      created_at: number,
      updated_at?: number | null,
      started_at?: number | null,
      finished_at?: number | null,
      error_msg?: string | null,
      configs?: string | null,
      allocation_type: AllocationType,
      input_ids?: Array< string | null > | null,
      mwaa_env?: string | null,
      dag_run_id?: string | null,
      scenario?: string | null,
      // Using string instead of enum to support names like "R&O Current", without having to map manually
      timeRange?: Array< string | null > | null,
      dag_tasks_status?: string | null,
      // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
      report_id?: string | null,
      is_shared?: boolean | null,
      userAlias: string,
      created_by?: string | null,
      updated_by?: string | null,
      started_by?: string | null,
      is_input_selected?: boolean | null,
      published_to_fpaone?: boolean | null,
      fpaone_publish_status?: string | null,
      sandbox_name?: string | null,
      shared_to_sandbox_ids?: Array< string | null > | null,
      shared_from_sandbox_id?: string | null,
      shared_from_sandbox_name?: string | null,
      comments?: string | null,
      allocation_pools?: string | null,
      ticket_id?: string | null,
      simulation_tag?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetReportDetailsQueryVariables = {
  sandbox_id?: string | null,
  report_id?: string | null,
  sim_id?: string | null,
};

export type GetReportDetailsQuery = {
  GetReportDetails?:  {
    __typename: "Report",
    sandbox_id: string,
    resource_key: string,
    status_key: string,
    resource_id: string,
    resource_type: ResourceType,
    is_active: boolean,
    status: ReportStatus,
    created_at: number,
    sim_id: string,
  } | null,
};

export type GetReportEmbedUrlQueryVariables = {
  user_id: string,
  sandbox_id: string,
  sim_id: string,
  allocation_type?: AllocationType | null,
  is_shared?: boolean | null,
};

export type GetReportEmbedUrlQuery = {
  GetReportEmbedUrl?: string | null,
};

export type GetSyncTimingsQueryVariables = {
  allocation_type?: AllocationType | null,
};

export type GetSyncTimingsQuery = {
  GetSyncTimings?:  {
    __typename: "SyncTimingResponse",
    allocationDefinitionSyncTime?: number | null,
    allocationMappingSyncTime?: number | null,
  } | null,
};

export type GetConfigurationsQueryVariables = {
  userAlias: string,
  configType?: ConfigType | null,
};

export type GetConfigurationsQuery = {
  GetConfigurations?:  {
    __typename: "GetConfigurationsResponse",
    content?: string | null,
  } | null,
};

export type ListScenariosQueryVariables = {
  sandbox_id?: string | null,
  allocation_type?: AllocationType | null,
  is_active: boolean,
  is_enabled: boolean,
  filter?: TableScenarioFilterRequest | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListScenariosQuery = {
  ListScenarios?:  {
    __typename: "ScenarioListPage",
    items?:  Array< {
      __typename: "Scenario",
      scenario_name: string,
      start_period: string,
      end_period: string,
      default_public: boolean,
      created_at: number,
      status: ScenarioStatus,
      status_key: string,
      resource_key: string,
      display_period: boolean,
      resource_id: string,
      sandbox_id?: string | null,
      allocation_type?: AllocationType | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOfCostpoolsInSimulationQueryVariables = {
  sandbox_id: string,
  sim_id: string,
  driver_type?: DriverType | null,
};

export type ListOfCostpoolsInSimulationQuery = {
  ListOfCostpoolsInSimulation?:  Array< {
    __typename: "SimulationCostPool",
    driver_type?: DriverType | null,
    costpool_id?: string | null,
    costpool_name?: string | null,
    driver_id?: string | null,
  } | null > | null,
};

export type ListOfDriversForImportQueryVariables = {
  sandbox_id: string,
  sim_id: string,
  costpool_ids?: Array< string | null > | null,
};

export type ListOfDriversForImportQuery = {
  ListOfDriversForImport?:  Array< {
    __typename: "CustomDriverDatasource",
    name?: string | null,
    created_time?: number | null,
    driver_id?: string | null,
    input_resource_key?: string | null,
    datasource_type?: InputSourceType | null,
  } | null > | null,
};

export type ListOfDriverTimePeriodQueryVariables = {
  sandbox_id: string,
  sim_id: string,
  costpool_ids?: Array< string | null > | null,
  driver_id?: string | null,
};

export type ListOfDriverTimePeriodQuery = {
  ListOfDriverTimePeriod?: Array< string | null > | null,
};

export type ListOfCustomDriversQueryVariables = {
  sandbox_id: string,
  sim_id: string,
  costpool_ids?: Array< string | null > | null,
  userAlias?: string | null,
  start?: number | null,
  limit?: number | null,
  group_by?: CustomDriverGroupBy | null,
};

export type ListOfCustomDriversQuery = {
  ListOfCustomDrivers?:  {
    __typename: "ListOfCustomDriverResponse",
    custom_driver_id?: string | null,
    custom_drivers?:  Array< {
      __typename: "SimulationCustomDriverMetadata",
      costpool_id?: string | null,
      timePeriod?: string | null,
      driver_id?: string | null,
      input_resource_key?: string | null,
      datasource_type?: InputSourceType | null,
    } | null > | null,
    custom_driver_count?: number | null,
    costpool_count?: number | null,
  } | null,
};

export type ListPublishedSimulationsQueryVariables = {
  sandbox_id?: string | null,
  filter?: SimBySandboxIdStatusFilterRequest | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPublishedSimulationsQuery = {
  ListPublishedSimulations?:  {
    __typename: "SimListPage",
    items?:  Array< {
      __typename: "Sim",
      sandbox_id: string,
      resource_key: string,
      status_key: string,
      resource_id: string,
      resource_type: ResourceType,
      is_active: boolean,
      name?: string | null,
      status: SimStatus,
      created_at: number,
      updated_at?: number | null,
      started_at?: number | null,
      finished_at?: number | null,
      error_msg?: string | null,
      configs?: string | null,
      allocation_type: AllocationType,
      input_ids?: Array< string | null > | null,
      mwaa_env?: string | null,
      dag_run_id?: string | null,
      scenario?: string | null,
      // Using string instead of enum to support names like "R&O Current", without having to map manually
      timeRange?: Array< string | null > | null,
      dag_tasks_status?: string | null,
      // json string `{task_id: task_state}`. TODO: convert to object representation for better control on content
      report_id?: string | null,
      is_shared?: boolean | null,
      userAlias: string,
      created_by?: string | null,
      updated_by?: string | null,
      started_by?: string | null,
      is_input_selected?: boolean | null,
      published_to_fpaone?: boolean | null,
      fpaone_publish_status?: string | null,
      sandbox_name?: string | null,
      shared_to_sandbox_ids?: Array< string | null > | null,
      shared_from_sandbox_id?: string | null,
      shared_from_sandbox_name?: string | null,
      comments?: string | null,
      allocation_pools?: string | null,
      ticket_id?: string | null,
      simulation_tag?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetPublicURLForSimulationReportQueryVariables = {
  sandbox_id: string,
  sim_id: string,
  userAlias: string,
};

export type GetPublicURLForSimulationReportQuery = {
  GetPublicURLForSimulationReport?: string | null,
};

export type GetMaxPeriodForDataSetsQueryVariables = {
  input?: GetMaxPeriodForDataSetsInput | null,
};

export type GetMaxPeriodForDataSetsQuery = {
  GetMaxPeriodForDataSets?:  {
    __typename: "GetMaxPeriodForDataSetsResponse",
    maxPeriodForDataSetList:  Array< {
      __typename: "DatasetMaxPeriod",
      dataSetName: string,
      maxPeriod: number,
    } | null >,
    maxPeriodForDataSets?: number | null,
  } | null,
};

export type SearchByTypeQueryVariables = {
  query: string,
  searchType: SearchType,
  limit?: number | null,
};

export type SearchByTypeQuery = {
  SearchByType?:  {
    __typename: "SearchResponse",
    results:  Array< {
      __typename: "SearchResult",
      id: string,
      name: string,
    } >,
  } | null,
};

export type ListCostPoolsQueryVariables = {
  id: string,
  name?: string | null,
  type: CostPoolListType,
  limit?: number | null,
  offset?: number | null,
};

export type ListCostPoolsQuery = {
  ListCostPools?:  {
    __typename: "ListCostPoolsResponse",
    costPools:  Array< {
      __typename: "CostPoolDetails",
      allocationPoolId: string,
      allocationPoolName: string,
      costCenters?: Array< string > | null,
      financeOwner?: string | null,
      lastUpdatedDate?: string | null,
    } >,
    hasMore: boolean,
  } | null,
};

export type GetCostPoolDetailsQueryVariables = {
  costPoolId: string,
  version?: number | null,
};

export type GetCostPoolDetailsQuery = {
  GetCostPoolDetails?:  {
    __typename: "GetCostPoolDetailsResponse",
    costPoolId: string,
    version:  {
      __typename: "CostPoolVersion",
      id: number,
      name: string,
    },
    definitions: string,
    mappings: string,
    driverDistribution: string,
  } | null,
};

export type GetConfigurationQueryVariables = {
  input: GetConfigurationRequest,
};

export type GetConfigurationQuery = {
  getConfiguration?:  {
    __typename: "GetConfigurationResponse",
    configs?: string | null,
    metadata?: string | null,
    user?: string | null,
  } | null,
};

export type GetListOfTenantsQueryVariables = {
};

export type GetListOfTenantsQuery = {
  getListOfTenants?:  {
    __typename: "TenantsList",
    tenants?: Array< string > | null,
  } | null,
};

export type GetListOfConfigurationsQueryVariables = {
  input: GetListOfConfigsRequest,
};

export type GetListOfConfigurationsQuery = {
  getListOfConfigurations?:  {
    __typename: "ConfigsList",
    configs?:  Array< {
      __typename: "ConfigInfo",
      configName: string,
      configType?: ConfigType | null,
      parentConfig?: string | null,
    } | null > | null,
  } | null,
};

export type RetrieveConfigurationsQueryVariables = {
  tenant: string,
  configList?: Array< RetrieveConfigListInput | null > | null,
  inheritFlag?: boolean | null,
};

export type RetrieveConfigurationsQuery = {
  retrieveConfigurations?:  {
    __typename: "RetrieveConfigurationsResponse",
    configsMap?:  Array< {
      __typename: "ConfigMapList",
      configName?: string | null,
      parentConfig?: string | null,
      configType?: ConfigType | null,
      configParams?: string | null,
      versionDescription?: string | null,
      metadata?: string | null,
      user?: string | null,
    } | null > | null,
  } | null,
};

export type GetListOfAccessibleTenantsQueryVariables = {
  input: GetListOfAccessibleTenantsRequest,
};

export type GetListOfAccessibleTenantsQuery = {
  getListOfAccessibleTenants?:  {
    __typename: "GetListOfAccessibleTenantsResponse",
    tenants?:  Array< {
      __typename: "TenantInfo",
      tenantName?: string | null,
      operation?: string | null,
    } > | null,
  } | null,
};

export type GetSchemaQueryVariables = {
  input?: GetSchemaRequest | null,
};

export type GetSchemaQuery = {
  GetSchema?:  {
    __typename: "GetSchemaResponse",
    attributeList?:  Array< {
      __typename: "AttributeSchema",
      attributeName?: string | null,
      attributeLabel?: string | null,
      attributeType?: string | null,
      isRequired?: boolean | null,
      isDisabled?: boolean | null,
      isHidden?: boolean | null,
      defaultValue?: string | null,
      description?: string | null,
      options?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type FetchExportedDataQueryVariables = {
  input?: FetchExportedDataRequest | null,
};

export type FetchExportedDataQuery = {
  FetchExportedData?:  {
    __typename: "FetchExportedDataResponse",
    attributeList?: Array< string | null > | null,
    data?: Array< Array< string | null > | null > | null,
    status?: ExportStatus | null,
    message?: string | null,
  } | null,
};

export type FetchPreSignedUrlQueryVariables = {
  input?: FetchPreSignedUrlRequest | null,
};

export type FetchPreSignedUrlQuery = {
  FetchPreSignedUrl?:  {
    __typename: "FetchPreSignedUrlResponse",
    url?: string | null,
    inputID?: string | null,
    status?: Status | null,
    message?: string | null,
    filePath?: string | null,
  } | null,
};

export type FetchDraftInputDetailsQueryVariables = {
  input?: FetchDraftInputDetailsRequest | null,
};

export type FetchDraftInputDetailsQuery = {
  FetchDraftInputDetails?:  {
    __typename: "FetchDraftInputDetailsResponse",
    status?: string | null,
    errorAttributeList?: Array< string | null > | null,
  } | null,
};

export type DownloadErrorDataQueryVariables = {
  input?: DownloadErrorDataRequest | null,
};

export type DownloadErrorDataQuery = {
  DownloadErrorData?:  {
    __typename: "DownloadErrorDataResponse",
    url?: string | null,
    status?: string | null,
    message?: string | null,
  } | null,
};

export type GetGFTOneUserSubscriptionQueryVariables = {
  id: string,
  name?: string | null,
};

export type GetGFTOneUserSubscriptionQuery = {
  getGFTOneUserSubscription?:  {
    __typename: "GFTOneUserSubscription",
    id: string,
    recipient?: string | null,
    app?: string | null,
    stage?: string | null,
    eventType?: string | null,
    resourceId?: string | null,
    channel?: string | null,
    createdOn?: number | null,
    lastModifiedOn?: number | null,
    expiresOn?: number | null,
  } | null,
};

export type GetGFTOneUINotificationsCountQueryVariables = {
  input?: GFTOneNotificationsInput | null,
};

export type GetGFTOneUINotificationsCountQuery = {
  getGFTOneUINotificationsCount?:  {
    __typename: "GFTOneUINotificationCount",
    count?: number | null,
  } | null,
};

export type GetGFTOneUINotificationsQueryVariables = {
  input?: GFTOneNotificationsInput | null,
};

export type GetGFTOneUINotificationsQuery = {
  getGFTOneUINotifications?:  {
    __typename: "getListOfNotifications",
    items?:  Array< {
      __typename: "UINotification",
      id?: string | null,
      app?: string | null,
      channel?: string | null,
      alias?: string | null,
      created_at?: string | null,
      eventType?: string | null,
      stageSystemKey?: string | null,
      seen?: boolean | null,
      read?: boolean | null,
      sender?: string | null,
    } | null > | null,
  } | null,
};

export type IsMemberOfGroupQueryVariables = {
  input: IsMemberOfGroupRequest,
};

export type IsMemberOfGroupQuery = {
  isMemberOfGroup?:  {
    __typename: "IsMemberOfGroupResponse",
    isMember?: boolean | null,
    status?: string | null,
  } | null,
};

export type IsAuthorizedQueryVariables = {
  input: IsAuthorizedBindleLockRequest,
};

export type IsAuthorizedQuery = {
  isAuthorized?:  {
    __typename: "IsAuthorizedBindleLockResponse",
    isAuthorized?: boolean | null,
    status?: string | null,
  } | null,
};

export type CanAccessQueryVariables = {
  input: CanAccessRequest,
};

export type CanAccessQuery = {
  canAccess?:  {
    __typename: "CanAccessResponse",
    isAuthorized?: boolean | null,
    status?: string | null,
  } | null,
};

export type CheckPermissionQueryVariables = {
  input: CheckPermissionRequest,
};

export type CheckPermissionQuery = {
  checkPermission?:  {
    __typename: "CheckPermissionResponse",
    resourceList?:  Array< {
      __typename: "ResourceInfo",
      operation?: string | null,
      namespace?: string | null,
      resourceType?: string | null,
      resourceName?: string | null,
    } | null > | null,
    status?: string | null,
  } | null,
};

export type CheckPermissionBatchQueryVariables = {
  input: CheckPermissionBatchRequest,
};

export type CheckPermissionBatchQuery = {
  checkPermissionBatch?:  {
    __typename: "CheckPermissionBatchResponse",
    resourceTypeList?:  Array< {
      __typename: "ResourceInfoBatchObject",
      resourceType?: string | null,
    } | null > | null,
    status?: string | null,
  } | null,
};

export type ListMemberOfGroupQueryVariables = {
  input: ListMemberOfGroupRequest,
};

export type ListMemberOfGroupQuery = {
  listMemberOfGroup?:  {
    __typename: "ListMemberOfGroupResponse",
    listOfMembers?:  Array< {
      __typename: "MemberInfo",
      actorID?: string | null,
      actorType?: string | null,
    } | null > | null,
  } | null,
};

export type ListBindleByOwnerQueryVariables = {
  input: ListBindleByOwnerRequest,
};

export type ListBindleByOwnerQuery = {
  listBindleByOwner?:  {
    __typename: "ListBindleByOwnerResponse",
    listOfBindles?:  Array< {
      __typename: "BindleInfo",
      bindleID?: string | null,
      bindleName?: string | null,
    } | null > | null,
  } | null,
};

export type GetFpaoneProductsCatalogQueryVariables = {
  productId: string,
  category: string,
};

export type GetFpaoneProductsCatalogQuery = {
  getFpaoneProductsCatalog?:  {
    __typename: "FpaoneProductsCatalog",
    category: string,
    productId: string,
    subCategory?: string | null,
    url?: string | null,
    description?: string | null,
    name?: string | null,
    wiki?: string | null,
    productType?: string | null,
    status?: string | null,
    accessGroups?: Array< string | null > | null,
  } | null,
};

export type ListFpaoneProductsCatalogsQueryVariables = {
};

export type ListFpaoneProductsCatalogsQuery = {
  listFpaoneProductsCatalogs?:  {
    __typename: "FpaoneProductsCatalogConnection",
    items?:  Array< {
      __typename: "FpaoneProductsCatalog",
      category: string,
      productId: string,
      subCategory?: string | null,
      url?: string | null,
      description?: string | null,
      name?: string | null,
      wiki?: string | null,
      productType?: string | null,
      status?: string | null,
      accessGroups?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type GetUserWorkspaceDetailsQueryVariables = {
  userId: string,
};

export type GetUserWorkspaceDetailsQuery = {
  getUserWorkspaceDetails?:  {
    __typename: "UserWorkspaceDetails",
    userId: string,
    productIds?: Array< string | null > | null,
  } | null,
};

export type ListUserWorkspaceDetailsQueryVariables = {
  filter?: TableUserWorkspaceDetailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserWorkspaceDetailsQuery = {
  listUserWorkspaceDetails?:  {
    __typename: "UserWorkspaceDetailsConnection",
    items?:  Array< {
      __typename: "UserWorkspaceDetails",
      userId: string,
      productIds?: Array< string | null > | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetGMUnitLockSummaryQueryVariables = {
};

export type GetGMUnitLockSummaryQuery = {
  getGMUnitLockSummary:  Array< {
    __typename: "AccountLock",
    accountName: string,
    lockStatus?: string | null,
  } >,
};

export type GetAllCategoriesQueryVariables = {
};

export type GetAllCategoriesQuery = {
  getAllCategories:  Array< {
    __typename: "ProductCategory",
    categoryId: string,
    categoryName: string,
    subcategories?:  Array< {
      __typename: "ProductSubCategory",
      subCategoryId: string,
      subCategoryName: string,
      parentCategoryId: string,
      status: StatusType,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null > | null,
    status: StatusType,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null >,
};

export type GetAllProductsQueryVariables = {
  productIds?: Array< string | null > | null,
  aliases?: Array< string | null > | null,
};

export type GetAllProductsQuery = {
  getAllProducts:  Array< {
    __typename: "ProductDetails",
    productId: string,
    name: string,
    description: string,
    info?: string | null,
    alias?: string | null,
    subCategoryId: string,
    subCategoryName: string,
    categoryId?: string | null,
    categoryName?: string | null,
    status: StatusType,
    productType: ProductType,
    accessGroups: Array< string >,
    ownerGroups?: Array< string > | null,
    QUICKSIGHT_DASHBOARD?:  {
      __typename: "ProductConfigQuicksight",
      accountId?: string | null,
      namespace?: string | null,
      dashboardId?: string | null,
      props?: string | null,
    } | null,
    APLIQO_DASHBOARD?:  {
      __typename: "ProductConfigApliqo",
      url?: string | null,
      props?: string | null,
    } | null,
    MICRO_FRONTEND?:  {
      __typename: "ProductConfigMicroFrontend",
      filePath?: string | null,
      exportApp?: string | null,
      props?: string | null,
    } | null,
    NATIVE_EXTERNAL?:  {
      __typename: "ProductConfigExternal",
      url?: string | null,
      props?: string | null,
    } | null,
    NATIVE_INTERNAL?:  {
      __typename: "ProductConfigInternal",
      name?: string | null,
      props?: string | null,
    } | null,
    accessType: ProductsAccessType,
    fintalkEnabled?: boolean | null,
    fintalkProps?: string | null,
    requestAccessLink?: string | null,
    featured?: number | null,
    wiki?: string | null,
    poc: string,
    ticketConfig?:  {
      __typename: "ProductTicketConfig",
      category?: string | null,
      type?: string | null,
    } | null,
    createdAt: string,
    createdBy: string,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null >,
};

export type GetProductsByCategoryQueryVariables = {
  categoryId: string,
};

export type GetProductsByCategoryQuery = {
  getProductsByCategory:  Array< {
    __typename: "ProductDetails",
    productId: string,
    name: string,
    description: string,
    info?: string | null,
    alias?: string | null,
    subCategoryId: string,
    subCategoryName: string,
    categoryId?: string | null,
    categoryName?: string | null,
    status: StatusType,
    productType: ProductType,
    accessGroups: Array< string >,
    ownerGroups?: Array< string > | null,
    QUICKSIGHT_DASHBOARD?:  {
      __typename: "ProductConfigQuicksight",
      accountId?: string | null,
      namespace?: string | null,
      dashboardId?: string | null,
      props?: string | null,
    } | null,
    APLIQO_DASHBOARD?:  {
      __typename: "ProductConfigApliqo",
      url?: string | null,
      props?: string | null,
    } | null,
    MICRO_FRONTEND?:  {
      __typename: "ProductConfigMicroFrontend",
      filePath?: string | null,
      exportApp?: string | null,
      props?: string | null,
    } | null,
    NATIVE_EXTERNAL?:  {
      __typename: "ProductConfigExternal",
      url?: string | null,
      props?: string | null,
    } | null,
    NATIVE_INTERNAL?:  {
      __typename: "ProductConfigInternal",
      name?: string | null,
      props?: string | null,
    } | null,
    accessType: ProductsAccessType,
    fintalkEnabled?: boolean | null,
    fintalkProps?: string | null,
    requestAccessLink?: string | null,
    featured?: number | null,
    wiki?: string | null,
    poc: string,
    ticketConfig?:  {
      __typename: "ProductTicketConfig",
      category?: string | null,
      type?: string | null,
    } | null,
    createdAt: string,
    createdBy: string,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null >,
};

export type GetQuicksightDashboardUrlQueryVariables = {
  productId: string,
  dashboardId?: string | null,
  accountId?: string | null,
  namespace?: string | null,
};

export type GetQuicksightDashboardUrlQuery = {
  getQuicksightDashboardUrl?:  {
    __typename: "QuickSightUrlOutput",
    quicksightUrl?: string | null,
  } | null,
};

export type GetAllSectionsQueryVariables = {
};

export type GetAllSectionsQuery = {
  getAllSections?:  Array< {
    __typename: "ResourcesSection",
    sectionId: string,
    sectionName: string,
    status?: StatusType | null,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    subsections?:  Array< {
      __typename: "ResourcesSubsection",
      subsectionId: string,
      subsectionName: string,
      description?: string | null,
      wikiLink?: string | null,
      contentURL?: string | null,
      parentSectionId: string,
      status?: StatusType | null,
      sortOrder?: number | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null > | null,
  } | null > | null,
};

export type GetSectionByIdQueryVariables = {
  sectionId: string,
};

export type GetSectionByIdQuery = {
  getSectionById?:  {
    __typename: "ResourcesSection",
    sectionId: string,
    sectionName: string,
    status?: StatusType | null,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    subsections?:  Array< {
      __typename: "ResourcesSubsection",
      subsectionId: string,
      subsectionName: string,
      description?: string | null,
      wikiLink?: string | null,
      contentURL?: string | null,
      parentSectionId: string,
      status?: StatusType | null,
      sortOrder?: number | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null > | null,
  } | null,
};

export type GetSubsectionsQueryVariables = {
  sectionId: string,
};

export type GetSubsectionsQuery = {
  getSubsections?:  Array< {
    __typename: "ResourcesSubsection",
    subsectionId: string,
    subsectionName: string,
    description?: string | null,
    wikiLink?: string | null,
    contentURL?: string | null,
    parentSectionId: string,
    status?: StatusType | null,
    sortOrder?: number | null,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null > | null,
};

export type GetAboutFPAOneQueryVariables = {
};

export type GetAboutFPAOneQuery = {
  getAboutFPAOne?:  {
    __typename: "AboutFPAOne",
    aboutId: string,
    about: string,
    poc: Array< string >,
    accessGroups: Array< string >,
    createdAt?: string | null,
    createdBy?: string | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
  } | null,
};

export type GetUserRolesQueryVariables = {
};

export type GetUserRolesQuery = {
  getUserRoles?:  {
    __typename: "UserAccessRoles",
    roles: Array< UserRoleType >,
  } | null,
};

export type ListTicketCategoriesQueryVariables = {
};

export type ListTicketCategoriesQuery = {
  // CTI (Category/Type/Item) listing queries
  listTicketCategories:  Array< {
    __typename: "CTINode",
    id?: string | null,
    label?: string | null,
    name: string,
  } >,
};

export type ListTicketTypesQueryVariables = {
  category: string,
};

export type ListTicketTypesQuery = {
  listTicketTypes:  Array< {
    __typename: "CTINode",
    id?: string | null,
    label?: string | null,
    name: string,
  } >,
};

export type ListTicketItemsQueryVariables = {
  category: string,
  type: string,
};

export type ListTicketItemsQuery = {
  listTicketItems:  Array< {
    __typename: "CTINode",
    id?: string | null,
    label?: string | null,
    name: string,
  } >,
};

export type GetUserGroupsQueryVariables = {
  userId: string,
  applicationId?: ApplicationId | null,
};

export type GetUserGroupsQuery = {
  getUserGroups?:  {
    __typename: "UserGroups",
    ldapGroups?: Array< string | null > | null,
    antGroups?: Array< string | null > | null,
  } | null,
};

export type QueryModularTableQueryVariables = {
  tableName: string,
  columns: Array< string >,
  filters?: string | null,
  limit?: number | null,
  resolveGuid?: boolean | null,
  distinct?: boolean | null,
  datasetNames?: Array< string > | null,
  scenario?: string | null,
};

export type QueryModularTableQuery = {
  queryModularTable:  {
    __typename: "ModularTableResponse",
    success: boolean,
    data: Array< string >,
    queryExecutionId?: string | null,
    error?: string | null,
  },
};

export type GetRunInfoLogQueryVariables = {
  runId: string,
  process: string,
};

export type GetRunInfoLogQuery = {
  getRunInfoLog:  {
    __typename: "RunInfoLogResponse",
    success: boolean,
    lines:  Array< {
      __typename: "RunInfoLogLine",
      timestamp: string,
      level: string,
      message: string,
    } >,
    lastUpdated?: string | null,
    error?: string | null,
  },
};

export type GetCsvFromS3QueryVariables = {
  bucket: string,
  keyPrefix: string,
};

export type GetCsvFromS3Query = {
  getCsvFromS3:  {
    __typename: "CsvFromS3Response",
    success: boolean,
    columns: Array< string >,
    rows: Array< string >,
    lastUpdated?: string | null,
    error?: string | null,
  },
};

export type RunQueryQueryVariables = {
  sql: string,
  maxRows?: number | null,
};

export type RunQueryQuery = {
  runQuery:  {
    __typename: "RunQueryResponse",
    success: boolean,
    data: Array< string >,
    error?: string | null,
  },
};

export type GetRunLineageQueryVariables = {
  runId: string,
  targetTable: string,
  outputTable?: string | null,
  datasetKey?: string | null,
};

export type GetRunLineageQuery = {
  getRunLineage:  {
    __typename: "RunLineageResponse",
    success: boolean,
    pairs: Array< string >,
    producer?: string | null,
    apiUrl?: string | null,
    tableName?: string | null,
    datasetName?: string | null,
    datasetMismatch?: boolean | null,
    error?: string | null,
  },
};

export type GetTableSchemaQueryVariables = {
  tableName: string,
};

export type GetTableSchemaQuery = {
  getTableSchema:  {
    __typename: "TableSchemaResponse",
    success: boolean,
    data:  Array< {
      __typename: "TableColumn",
      columnName: string,
      dataType: string,
      comment?: string | null,
    } >,
    tableName: string,
    error?: string | null,
  },
};

export type GetLatestGuidQueryVariables = {
  datasetName: string,
};

export type GetLatestGuidQuery = {
  getLatestGuid:  {
    __typename: "LatestGuidResponse",
    success: boolean,
    guid?: string | null,
    error?: string | null,
  },
};

export type GetGuidPeriodPairsQueryVariables = {
  datasetName: string,
  scenario?: string | null,
};

export type GetGuidPeriodPairsQuery = {
  getGuidPeriodPairs:  {
    __typename: "GuidPeriodPairsResponse",
    success: boolean,
    pairs?:  Array< {
      __typename: "GuidPeriodPair",
      guid: string,
      period: string,
      s3Location?: string | null,
    } > | null,
    truncated?: boolean | null,
    error?: string | null,
  },
};

export type CheckPartitionsHaveFilesQueryVariables = {
  datasetName: string,
  scenario?: string | null,
  periods: Array< string >,
  tableName?: string | null,
};

export type CheckPartitionsHaveFilesQuery = {
  checkPartitionsHaveFiles:  {
    __typename: "CheckPartitionsHaveFilesResponse",
    success: boolean,
    results?:  Array< {
      __typename: "PartitionFilePresence",
      period: string,
      hasFiles?: boolean | null,
      error?: string | null,
    } > | null,
    error?: string | null,
  },
};

export type GetDataHealthQueryVariables = {
  datasetName: string,
  scenario?: string | null,
  startPeriod: string,
  endPeriod: string,
};

export type GetDataHealthQuery = {
  getDataHealth:  {
    __typename: "DataHealthResponse",
    success: boolean,
    lastSweptAt?: string | null,
    entries?:  Array< {
      __typename: "DataHealthEntry",
      period: string,
      verdict: string,
    } > | null,
    minPeriod?: string | null,
    maxPeriod?: string | null,
    error?: string | null,
  },
};

export type GetQueryStatusQueryVariables = {
  queryExecutionId: string,
};

export type GetQueryStatusQuery = {
  getQueryStatus:  {
    __typename: "QueryStatusResponse",
    success: boolean,
    queryExecutionId: string,
    status: string,
    dataScannedBytes?: number | null,
    engineExecutionTimeMillis?: number | null,
    totalExecutionTimeMillis?: number | null,
    error?: string | null,
  },
};

export type GetQueryResultsQueryVariables = {
  queryExecutionId: string,
  nextToken?: string | null,
  pageSize?: number | null,
};

export type GetQueryResultsQuery = {
  getQueryResults:  {
    __typename: "QueryResultsResponse",
    success: boolean,
    data: Array< string >,
    queryExecutionId: string,
    nextToken?: string | null,
    hasNextPage: boolean,
    error?: string | null,
  },
};

export type GetRecordQueryVariables = {
  input: GetRecordInput,
};

export type GetRecordQuery = {
  getRecord:  {
    __typename: "RecordResponse",
    success: boolean,
    message: string,
    data?: string | null,
    tableName: string,
    recordId?: string | null,
    error?: string | null,
    // Optional outcome of the BE update post-processor side-effect (e.g.
    // Kinesis approval-event publish for cashflow). Tri-valued via
    // presence: omitted when no side-effect ran (most processes / writes),
    // ``true`` on a successful publish, ``false`` on a failed publish.
    // The FE reads this on ``updateRecord`` to append a "Notification
    // sent" clause to the success banner — see ``RunDetails.tsx``.
    notificationsPublished?: boolean | null,
  },
};

export type ListRecordsQueryVariables = {
  input: ListRecordsInput,
};

export type ListRecordsQuery = {
  listRecords:  {
    __typename: "RecordListResponse",
    success: boolean,
    data: Array< string >,
    tableName: string,
    totalCount?: number | null,
    nextToken?: string | null,
    error?: string | null,
  },
};

export type GetDependencyDataQueryVariables = {
  input: GetDependencyDataInput,
};

export type GetDependencyDataQuery = {
  getDependencyData:  {
    __typename: "DependencyDataResponse",
    success: boolean,
    data: Array< string >,
    tableName: string,
    dependencyTable: string,
    runId: string,
    guid?: string | null,
    mode: ConfigMode,
    queryExecutionId?: string | null,
    pagination?:  {
      __typename: "PaginationInfo",
      hasNextPage: boolean,
      totalCount: number,
      pageSize: number,
      currentPage: number,
    } | null,
    nextToken?: string | null,
    error?: string | null,
  },
};

export type GetChartDataQueryVariables = {
  input: GetChartDataInput,
};

export type GetChartDataQuery = {
  getChartData:  {
    __typename: "ChartDataResponse",
    success: boolean,
    forecast: Array< string >,
    actuals: Array< string >,
    forecastQueryId?: string | null,
    actualsQueryId?: string | null,
    error?: string | null,
    errorCode?: string | null,
  },
};

export type GetChartFiltersQueryVariables = {
  input: GetChartFiltersInput,
};

export type GetChartFiltersQuery = {
  getChartFilters:  {
    __typename: "ChartFiltersResponse",
    success: boolean,
    filterValues: string,
    error?: string | null,
  },
};

export type GetActualsTimeseriesQueryVariables = {
  input: GetActualsTimeseriesInput,
};

export type GetActualsTimeseriesQuery = {
  getActualsTimeseries:  {
    __typename: "ActualsTimeseriesResponse",
    success: boolean,
    rows: Array< string >,
    queryId?: string | null,
    minPeriod?: string | null,
    maxPeriod?: string | null,
    error?: string | null,
  },
};

export type GetActualsDistinctValuesQueryVariables = {
  input: GetActualsDistinctValuesInput,
};

export type GetActualsDistinctValuesQuery = {
  getActualsDistinctValues:  {
    __typename: "ChartFiltersResponse",
    success: boolean,
    filterValues: string,
    error?: string | null,
  },
};

export type CheckActualsMembershipQueryVariables = {
  input: CheckActualsMembershipInput,
};

export type CheckActualsMembershipQuery = {
  checkActualsMembership:  {
    __typename: "CheckActualsMembershipResponse",
    success: boolean,
    inData?: Array< string > | null,
    error?: string | null,
  },
};

export type GetHierarchyDescendantsQueryVariables = {
  input: GetHierarchyDescendantsInput,
};

export type GetHierarchyDescendantsQuery = {
  getHierarchyDescendants:  {
    __typename: "HierarchyDescendantsResponse",
    success: boolean,
    descendants: string,
    encoding?: string | null,
    idToName?: string | null,
    idToNameEncoding?: string | null,
    status?: string | null,
    queryExecutionId?: string | null,
    error?: string | null,
  },
};

export type GetHierarchyTopologyStatusQueryVariables = {
  input: GetHierarchyTopologyStatusInput,
};

export type GetHierarchyTopologyStatusQuery = {
  getHierarchyTopologyStatus:  {
    __typename: "HierarchyDescendantsResponse",
    success: boolean,
    descendants: string,
    encoding?: string | null,
    idToName?: string | null,
    idToNameEncoding?: string | null,
    status?: string | null,
    queryExecutionId?: string | null,
    error?: string | null,
  },
};

export type SearchDimSumNodesQueryVariables = {
  input: SearchDimSumNodesInput,
};

export type SearchDimSumNodesQuery = {
  searchDimSumNodes:  {
    __typename: "DimSumSearchResponse",
    nodes?:  Array< {
      __typename: "DimSumNode",
      id: string,
      nodeID: string,
      name: string,
      description?: string | null,
      keyFull?: Array< string | null > | null,
    } > | null,
    total?: number | null,
    hasMore?: boolean | null,
    parentNodes?:  Array< {
      __typename: "DimSumNode",
      id: string,
      nodeID: string,
      name: string,
      description?: string | null,
      keyFull?: Array< string | null > | null,
    } > | null,
    enabled?: boolean | null,
  },
};

export type GetDimSumRootsQueryVariables = {
  dimensionID: string,
};

export type GetDimSumRootsQuery = {
  getDimSumRoots:  {
    __typename: "DimSumNodesResponse",
    nodes?:  Array< {
      __typename: "DimSumNode",
      id: string,
      nodeID: string,
      name: string,
      description?: string | null,
      keyFull?: Array< string | null > | null,
    } > | null,
    enabled?: boolean | null,
  },
};

export type GetDimSumChildrenQueryVariables = {
  input: GetDimSumChildrenInput,
};

export type GetDimSumChildrenQuery = {
  getDimSumChildren:  {
    __typename: "DimSumSearchResponse",
    nodes?:  Array< {
      __typename: "DimSumNode",
      id: string,
      nodeID: string,
      name: string,
      description?: string | null,
      keyFull?: Array< string | null > | null,
    } > | null,
    total?: number | null,
    hasMore?: boolean | null,
    parentNodes?:  Array< {
      __typename: "DimSumNode",
      id: string,
      nodeID: string,
      name: string,
      description?: string | null,
      keyFull?: Array< string | null > | null,
    } > | null,
    enabled?: boolean | null,
  },
};

export type GetDdbExportStatusQueryVariables = {
  taskId: string,
};

export type GetDdbExportStatusQuery = {
  getDdbExportStatus:  {
    __typename: "DdbExportStatusResponse",
    success: boolean,
    taskId?: string | null,
    status?: string | null,
    rowsWritten?: number | null,
    completedAt?: string | null,
    startedAt?: string | null,
    targetTableName?: string | null,
    error?: string | null,
    errorCode?: string | null,
  },
};

export type ListInProgressExportsQueryVariables = {
  targetTableName: string,
};

export type ListInProgressExportsQuery = {
  listInProgressExports:  {
    __typename: "DdbExportTaskListResponse",
    success: boolean,
    tasks:  Array< {
      __typename: "DdbExportTaskRow",
      taskId: string,
      targetTableName: string,
      status: string,
      startedAt?: string | null,
      lastUpdatedAt?: string | null,
      rowsWritten?: number | null,
    } >,
    error?: string | null,
  },
};

export type FetchInputUploadStatusSubscriptionVariables = {
  sim_id: string,
  metadata_id: string,
  metadata?: string | null,
  userAlias?: string | null,
};

export type FetchInputUploadStatusSubscription = {
  FetchInputUploadStatus?:  {
    __typename: "UploadStatusType",
    status: UploadStatus,
    validateError?: Array< string | null > | null,
    errorDownloadUrl?: Array< string | null > | null,
  } | null,
};

export type OnFileUploadStatusSubscriptionVariables = {
  simulationKey: string,
  metadataId: string,
};

export type OnFileUploadStatusSubscription = {
  onFileUploadStatus?:  {
    __typename: "FileUploadStatusResponse",
    metadataId: string,
    simulationKey: string,
    status: string,
    errors?: Array< string | null > | null,
  } | null,
};
